import {assetUrl} from "../../serviceApi";

const img_0 = assetUrl+'images/img_0.png'
const img_1 = assetUrl+'images/img_1.png'
const img_2 = assetUrl+'images/img_2.png'
const img_3 = assetUrl+'images/img_3.png'
const img_4 = assetUrl+'images/img_4.png'
const img_5 = assetUrl+'images/img_5.png'
const img_6 = assetUrl+'images/img_6.png'
const img_7 = assetUrl+'images/img_7.png'
const img_9 = assetUrl+'images/img_9.png'
const img_8 = assetUrl+'images/img_8.png'
const img_10 = assetUrl+'images/img_10.png'
const img_11 = assetUrl+'images/img_11.png'
const img_12 = assetUrl+'images/img_12.png'
const img_13 = assetUrl+'images/img_13.png'






export const animationData = {
	"v": "5.7.4",
	"fr": 60,
	"ip": 0,
	"op": 280,
	"w": 376,
	"h": 812,
	"nm": "splash screen_update",
	"ddd": 0,
	"assets": [{
		"id": "image_0",
		"w": 2048,
		"h": 2048,
		"u": "",
		"p": img_0,
		"e": 0
	}, {"id": "image_1", "w": 2048, "h": 2048, "u": "", "p": img_1, "e": 0}, {
		"id": "image_2",
		"w": 2048,
		"h": 2048,
		"u": "",
		"p": img_2,
		"e": 0
	}, {"id": "image_3", "w": 2048, "h": 2048, "u": "", "p": img_3, "e": 0}, {
		"id": "image_4",
		"w": 2048,
		"h": 2048,
		"u": "",
		"p": img_4,
		"e": 0
	}, {"id": "image_5", "w": 2048, "h": 2048, "u": "", "p": img_5, "e": 0}, {
		"id": "image_6",
		"w": 958,
		"h": 1769,
		"u": "",
		"p": img_6,
		"e": 0
	}, {"id": "image_7", "w": 467, "h": 765, "u": "", "p": img_7, "e": 0}, {
		"id": "image_8",
		"w": 335,
		"h": 526,
		"u": "",
		"p": img_8,
		"e": 0
	}, {"id": "image_9", "w": 294, "h": 282, "u": "", "p": img_9, "e": 0}, {
		"id": "image_10",
		"w": 2048,
		"h": 2048,
		"u": "",
		"p": img_10,
		"e": 0
	}, {"id": "image_11", "w": 706, "h": 824, "u": "", "p": img_11, "e": 0}, {
		"id": "image_12",
		"w": 411,
		"h": 418,
		"u": "",
		"p": img_12,
		"e": 0
	}, {"id": "image_13", "w": 31, "h": 30, "u": "", "p": img_13, "e": 0}, {
		"id": "comp_0",
		"layers": [{
			"ddd": 0,
			"ind": 1,
			"ty": 2,
			"nm": "specs",
			"parent": 16,
			"refId": "image_0",
			"sr": 1,
			"ks": {
				"o": {"a": 0, "k": 100, "ix": 11},
				"r": {"a": 0, "k": 0, "ix": 10},
				"p": {"a": 0, "k": [257, 400, 0], "ix": 2, "l": 2},
				"a": {"a": 0, "k": [1024, 1024, 0], "ix": 1, "l": 2},
				"s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
			},
			"ao": 0,
			"ip": 0,
			"op": 600,
			"st": 0,
			"bm": 0
		}, {
			"ddd": 0,
			"ind": 2,
			"ty": 2,
			"nm": "lips",
			"parent": 16,
			"refId": "image_1",
			"sr": 1,
			"ks": {
				"o": {"a": 0, "k": 100, "ix": 11},
				"r": {"a": 0, "k": 0, "ix": 10},
				"p": {"a": 0, "k": [257, 400, 0], "ix": 2, "l": 2},
				"a": {"a": 0, "k": [1024, 1024, 0], "ix": 1, "l": 2},
				"s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
			},
			"ao": 0,
			"ip": 0,
			"op": 600,
			"st": 0,
			"bm": 0
		}, {
			"ddd": 0,
			"ind": 3,
			"ty": 2,
			"nm": "eyebrows",
			"parent": 16,
			"refId": "image_2",
			"sr": 1,
			"ks": {
				"o": {"a": 0, "k": 100, "ix": 11},
				"r": {"a": 0, "k": 0, "ix": 10},
				"p": {"a": 0, "k": [257, 400, 0], "ix": 2, "l": 2},
				"a": {"a": 0, "k": [1024, 1024, 0], "ix": 1, "l": 2},
				"s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
			},
			"ao": 0,
			"ip": 0,
			"op": 600,
			"st": 0,
			"bm": 0
		}, {
			"ddd": 0,
			"ind": 4,
			"ty": 4,
			"nm": "Shape Layer 3",
			"sr": 1,
			"ks": {
				"o": {"a": 0, "k": 100, "ix": 11},
				"r": {"a": 0, "k": -9.829, "ix": 10},
				"p": {"a": 0, "k": [848.738, 790.02, 0], "ix": 2, "l": 2},
				"a": {"a": 0, "k": [0.345, -12.675, 0], "ix": 1, "l": 2},
				"s": {"a": 0, "k": [133, 113.554, 100], "ix": 6, "l": 2}
			},
			"ao": 0,
			"shapes": [{
				"ind": 0, "ty": "sh", "ix": 1, "ks": {
					"a": 1,
					"k": [{
						"i": {"x": 0.667, "y": 1},
						"o": {"x": 0.333, "y": 0},
						"t": 32,
						"s": [{
							"i": [[-7.594, 0], [-0.354, -13.997], [5.344, 0.102], [1.091, -13.34]],
							"o": [[7.594, 0], [-0.908, -16.852], [-4.931, -0.094], [0.697, -10.677]],
							"v": [[0.568, -24.385], [13.568, -1.408], [0.014, -24.416], [-12.879, -3.252]],
							"c": true
						}]
					}, {
						"i": {"x": 0.667, "y": 1},
						"o": {"x": 0.333, "y": 0},
						"t": 34,
						"s": [{
							"i": [[-7.594, 0], [-0.354, -13.997], [5.344, 0.102], [4.573, -2.575]],
							"o": [[7.594, 0], [-4.517, -4.326], [-4.931, -0.094], [0.697, -10.677]],
							"v": [[0.503, -23.941], [13.568, -1.408], [0.18, -8.381], [-12.879, -3.252]],
							"c": true
						}]
					}, {
						"i": {"x": 0.667, "y": 1},
						"o": {"x": 0.333, "y": 0},
						"t": 36,
						"s": [{
							"i": [[-7.594, 0], [1.553, -21.61], [6.423, -0.593], [1.89, 2.366]],
							"o": [[7.594, 0], [-4.004, 0.122], [-3.549, 0.328], [-3.598, -17.264]],
							"v": [[0, -24.5], [14.329, 4.004], [1.712, 6.331], [-12.519, 6.193]],
							"c": true
						}]
					}, {
						"i": {"x": 0.667, "y": 1},
						"o": {"x": 0.167, "y": 0},
						"t": 38,
						"s": [{
							"i": [[-7.594, 0], [0, -13.531], [7.594, 0], [0, 13.531]],
							"o": [[7.594, 0], [0, 13.531], [-7.594, 0], [0, -13.531]],
							"v": [[0, -24.5], [13.75, 0], [0, 24.5], [-13.75, 0]],
							"c": true
						}]
					}, {
						"i": {"x": 0.667, "y": 1},
						"o": {"x": 0.167, "y": 0},
						"t": 44,
						"s": [{
							"i": [[-7.594, 0], [0, -13.531], [7.594, 0], [0, 13.531]],
							"o": [[7.594, 0], [0, 13.531], [-7.594, 0], [0, -13.531]],
							"v": [[0, -24.5], [13.75, 0], [0, 24.5], [-13.75, 0]],
							"c": true
						}]
					}, {
						"i": {"x": 0.667, "y": 1},
						"o": {"x": 0.333, "y": 0},
						"t": 46,
						"s": [{
							"i": [[-7.594, 0], [1.553, -21.61], [6.423, -0.593], [1.89, 2.366]],
							"o": [[7.594, 0], [-4.004, 0.122], [-3.549, 0.328], [-3.598, -17.264]],
							"v": [[0, -24.5], [14.329, 4.004], [1.712, 6.331], [-12.519, 6.193]],
							"c": true
						}]
					}, {
						"i": {"x": 0.667, "y": 1},
						"o": {"x": 0.333, "y": 0},
						"t": 48,
						"s": [{
							"i": [[-7.594, 0], [-0.354, -13.997], [5.344, 0.102], [4.573, -2.575]],
							"o": [[7.594, 0], [-4.517, -4.326], [-4.931, -0.094], [0.697, -10.677]],
							"v": [[0.503, -23.941], [13.568, -1.408], [0.18, -8.381], [-12.879, -3.252]],
							"c": true
						}]
					}, {
						"t": 50,
						"s": [{
							"i": [[-7.594, 0], [-0.354, -13.997], [5.344, 0.102], [1.091, -13.34]],
							"o": [[7.594, 0], [-0.908, -16.852], [-4.931, -0.094], [0.697, -10.677]],
							"v": [[0.568, -24.385], [13.568, -1.408], [0.014, -24.416], [-12.879, -3.252]],
							"c": true
						}]
					}],
					"ix": 2
				}, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false
			}, {
				"ty": "st",
				"c": {"a": 0, "k": [1, 1, 1, 1], "ix": 3},
				"o": {"a": 0, "k": 100, "ix": 4},
				"w": {"a": 0, "k": 0, "ix": 5},
				"lc": 1,
				"lj": 1,
				"ml": 4,
				"bm": 0,
				"nm": "Stroke 1",
				"mn": "ADBE Vector Graphic - Stroke",
				"hd": false
			}, {
				"ty": "fl",
				"c": {"a": 0, "k": [0.839215746113, 0.411764735802, 0.321568627451, 1], "ix": 4},
				"o": {"a": 0, "k": 100, "ix": 5},
				"r": 1,
				"bm": 0,
				"nm": "Fill 1",
				"mn": "ADBE Vector Graphic - Fill",
				"hd": false
			}],
			"ip": 0,
			"op": 600,
			"st": 0,
			"bm": 0
		}, {
			"ddd": 0,
			"ind": 5,
			"ty": 4,
			"nm": "Shape Layer 1",
			"sr": 1,
			"ks": {
				"o": {"a": 0, "k": 100, "ix": 11},
				"r": {"a": 0, "k": -9.829, "ix": 10},
				"p": {"a": 0, "k": [1035.488, 749.02, 0], "ix": 2, "l": 2},
				"a": {"a": 0, "k": [0.345, -12.675, 0], "ix": 1, "l": 2},
				"s": {"a": 0, "k": [133, 113.554, 100], "ix": 6, "l": 2}
			},
			"ao": 0,
			"shapes": [{
				"ind": 0, "ty": "sh", "ix": 1, "ks": {
					"a": 1,
					"k": [{
						"i": {"x": 0.667, "y": 1},
						"o": {"x": 0.333, "y": 0},
						"t": 32,
						"s": [{
							"i": [[-7.594, 0], [-0.354, -13.997], [5.344, 0.102], [1.091, -13.34]],
							"o": [[7.594, 0], [-0.908, -16.852], [-4.931, -0.094], [0.697, -10.677]],
							"v": [[0.568, -24.385], [13.568, -1.408], [0.014, -24.416], [-12.879, -3.252]],
							"c": true
						}]
					}, {
						"i": {"x": 0.667, "y": 1},
						"o": {"x": 0.333, "y": 0},
						"t": 34,
						"s": [{
							"i": [[-7.594, 0], [-0.354, -13.997], [5.344, 0.102], [4.573, -2.575]],
							"o": [[7.594, 0], [-4.517, -4.326], [-4.931, -0.094], [0.697, -10.677]],
							"v": [[0.503, -23.941], [13.568, -1.408], [0.18, -8.381], [-12.879, -3.252]],
							"c": true
						}]
					}, {
						"i": {"x": 0.667, "y": 1},
						"o": {"x": 0.333, "y": 0},
						"t": 36,
						"s": [{
							"i": [[-7.594, 0], [1.553, -21.61], [6.423, -0.593], [1.89, 2.366]],
							"o": [[7.594, 0], [-4.004, 0.122], [-3.549, 0.328], [-3.598, -17.264]],
							"v": [[0, -24.5], [14.329, 4.004], [1.712, 6.331], [-12.519, 6.193]],
							"c": true
						}]
					}, {
						"i": {"x": 0.667, "y": 1},
						"o": {"x": 0.167, "y": 0},
						"t": 38,
						"s": [{
							"i": [[-7.594, 0], [0, -13.531], [7.594, 0], [0, 13.531]],
							"o": [[7.594, 0], [0, 13.531], [-7.594, 0], [0, -13.531]],
							"v": [[0, -24.5], [13.75, 0], [0, 24.5], [-13.75, 0]],
							"c": true
						}]
					}, {
						"i": {"x": 0.667, "y": 1},
						"o": {"x": 0.167, "y": 0},
						"t": 44,
						"s": [{
							"i": [[-7.594, 0], [0, -13.531], [7.594, 0], [0, 13.531]],
							"o": [[7.594, 0], [0, 13.531], [-7.594, 0], [0, -13.531]],
							"v": [[0, -24.5], [13.75, 0], [0, 24.5], [-13.75, 0]],
							"c": true
						}]
					}, {
						"i": {"x": 0.667, "y": 1},
						"o": {"x": 0.333, "y": 0},
						"t": 46,
						"s": [{
							"i": [[-7.594, 0], [1.553, -21.61], [6.423, -0.593], [1.89, 2.366]],
							"o": [[7.594, 0], [-4.004, 0.122], [-3.549, 0.328], [-3.598, -17.264]],
							"v": [[0, -24.5], [14.329, 4.004], [1.712, 6.331], [-12.519, 6.193]],
							"c": true
						}]
					}, {
						"i": {"x": 0.667, "y": 1},
						"o": {"x": 0.333, "y": 0},
						"t": 48,
						"s": [{
							"i": [[-7.594, 0], [-0.354, -13.997], [5.344, 0.102], [4.573, -2.575]],
							"o": [[7.594, 0], [-4.517, -4.326], [-4.931, -0.094], [0.697, -10.677]],
							"v": [[0.503, -23.941], [13.568, -1.408], [0.18, -8.381], [-12.879, -3.252]],
							"c": true
						}]
					}, {
						"t": 50,
						"s": [{
							"i": [[-7.594, 0], [-0.354, -13.997], [5.344, 0.102], [1.091, -13.34]],
							"o": [[7.594, 0], [-0.908, -16.852], [-4.931, -0.094], [0.697, -10.677]],
							"v": [[0.568, -24.385], [13.568, -1.408], [0.014, -24.416], [-12.879, -3.252]],
							"c": true
						}]
					}],
					"ix": 2
				}, "nm": "Path 1", "mn": "ADBE Vector Shape - Group", "hd": false
			}, {
				"ty": "st",
				"c": {"a": 0, "k": [1, 1, 1, 1], "ix": 3},
				"o": {"a": 0, "k": 100, "ix": 4},
				"w": {"a": 0, "k": 0, "ix": 5},
				"lc": 1,
				"lj": 1,
				"ml": 4,
				"bm": 0,
				"nm": "Stroke 1",
				"mn": "ADBE Vector Graphic - Stroke",
				"hd": false
			}, {
				"ty": "fl",
				"c": {"a": 0, "k": [0.839215746113, 0.411764735802, 0.321568627451, 1], "ix": 4},
				"o": {"a": 0, "k": 100, "ix": 5},
				"r": 1,
				"bm": 0,
				"nm": "Fill 1",
				"mn": "ADBE Vector Graphic - Fill",
				"hd": false
			}],
			"ip": 0,
			"op": 600,
			"st": 0,
			"bm": 0
		}, {
			"ddd": 0,
			"ind": 6,
			"ty": 2,
			"nm": "left eye",
			"parent": 16,
			"refId": "image_3",
			"sr": 1,
			"ks": {
				"o": {"a": 0, "k": 100, "ix": 11},
				"r": {"a": 0, "k": 0, "ix": 10},
				"p": {"a": 0, "k": [270, 140, 0], "ix": 2, "l": 2},
				"a": {"a": 0, "k": [1037, 764, 0], "ix": 1, "l": 2},
				"s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
			},
			"ao": 0,
			"ip": 0,
			"op": 600,
			"st": 0,
			"bm": 0
		}, {
			"ddd": 0,
			"ind": 7,
			"ty": 2,
			"nm": "right eye",
			"parent": 16,
			"refId": "image_4",
			"sr": 1,
			"ks": {
				"o": {"a": 0, "k": 100, "ix": 11},
				"r": {"a": 0, "k": 0, "ix": 10},
				"p": {"a": 0, "k": [83, 181, 0], "ix": 2, "l": 2},
				"a": {"a": 0, "k": [850, 805, 0], "ix": 1, "l": 2},
				"s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
			},
			"ao": 0,
			"ip": 0,
			"op": 600,
			"st": 0,
			"bm": 0
		}, {
			"ddd": 0,
			"ind": 8,
			"ty": 2,
			"nm": "hat",
			"parent": 16,
			"refId": "image_5",
			"sr": 1,
			"ks": {
				"o": {"a": 0, "k": 100, "ix": 11},
				"r": {"a": 0, "k": 0, "ix": 10},
				"p": {"a": 0, "k": [257, 400, 0], "ix": 2, "l": 2},
				"a": {"a": 0, "k": [1024, 1024, 0], "ix": 1, "l": 2},
				"s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
			},
			"ao": 0,
			"ip": 0,
			"op": 600,
			"st": 0,
			"bm": 0
		}, {
			"ddd": 0,
			"ind": 9,
			"ty": 2,
			"nm": "left hand 2",
			"parent": 10,
			"refId": "image_6",
			"sr": 1,
			"ks": {
				"o": {"a": 0, "k": 100, "ix": 11},
				"r": {
					"a": 1,
					"k": [{"i": {"x": [0.4], "y": [1]}, "o": {"x": [0.333], "y": [0]}, "t": 10, "s": [55]}, {
						"t": 30,
						"s": [0]
					}],
					"ix": 10
				},
				"p": {
					"a": 1,
					"k": [{
						"i": {"x": 0.425, "y": 1},
						"o": {"x": 0.389, "y": 0},
						"t": 10,
						"s": [139.758, 1652.103, 0],
						"to": [0, 0, 0],
						"ti": [0, 0, 0]
					}, {"t": 30, "s": [167.5, 1660, 0]}],
					"ix": 2,
					"l": 2
				},
				"a": {"a": 0, "k": [167.5, 1660, 0], "ix": 1, "l": 2},
				"s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
			},
			"ao": 0,
			"hasMask": true,
			"masksProperties": [{
				"inv": false,
				"mode": "a",
				"pt": {
					"a": 0,
					"k": {
						"i": [[0, 0], [14, -26], [-32, -40], [-38, 34], [0, 0], [0, 0]],
						"o": [[0, 0], [-14, 26], [32, 40], [38, -34], [0, 0], [0, 0]],
						"v": [[267, 1036], [-59, 1078], [75, 1618], [225, 1626], [239, 1518], [335, 1398]],
						"c": true
					},
					"ix": 1
				},
				"o": {"a": 0, "k": 100, "ix": 3},
				"x": {"a": 0, "k": 0, "ix": 4},
				"nm": "Mask 1"
			}],
			"ip": 0,
			"op": 600,
			"st": 0,
			"bm": 0
		}, {
			"ddd": 0,
			"ind": 10,
			"ty": 2,
			"nm": "left hand 3",
			"parent": 15,
			"refId": "image_6",
			"sr": 1,
			"ks": {
				"o": {"a": 0, "k": 100, "ix": 11},
				"r": {
					"a": 1,
					"k": [{"i": {"x": [0.4], "y": [1]}, "o": {"x": [0.333], "y": [0]}, "t": 10, "s": [-44]}, {
						"t": 30,
						"s": [0]
					}],
					"ix": 10
				},
				"p": {
					"a": 1,
					"k": [{
						"i": {"x": 0.4, "y": 1},
						"o": {"x": 0.333, "y": 0},
						"t": 10,
						"s": [55.864, 326.423, 0],
						"to": [-2.811, 5.68, 0],
						"ti": [0, 0, 0]
					}, {"t": 30, "s": [39, 360.5, 0]}],
					"ix": 2,
					"l": 2
				},
				"a": {"a": 0, "k": [503.5, 1412, 0], "ix": 1, "l": 2},
				"s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
			},
			"ao": 0,
			"hasMask": true,
			"masksProperties": [{
				"inv": false,
				"mode": "a",
				"pt": {
					"a": 0,
					"k": {
						"i": [[0, 0], [14, -26], [358.343, -56.983], [1.738, 26.563], [-43.15, 27.168], [0, 0], [0, 0]],
						"o": [[0, 0], [-6.725, 12.489], [-174.125, 27.689], [-3.5, -53.5], [40.5, -25.5], [0, 0], [0, 0]],
						"v": [[481, 1280], [705, 1364], [399.157, 1790.483], [81, 1636], [132, 1521], [238, 1515], [289, 1464]],
						"c": true
					},
					"ix": 1
				},
				"o": {"a": 0, "k": 100, "ix": 3},
				"x": {"a": 0, "k": 0, "ix": 4},
				"nm": "Mask 1"
			}],
			"ip": 0,
			"op": 600,
			"st": 0,
			"bm": 0
		}, {
			"ddd": 0,
			"ind": 11,
			"ty": 2,
			"nm": "right hand",
			"parent": 13,
			"refId": "image_7",
			"sr": 1,
			"ks": {
				"o": {"a": 0, "k": 100, "ix": 11},
				"r": {
					"a": 1,
					"k": [{
						"i": {"x": [0.4], "y": [1]},
						"o": {"x": [0.333], "y": [0]},
						"t": 10,
						"s": [-125.698]
					}, {"t": 30, "s": [0.275]}],
					"ix": 10
				},
				"p": {
					"a": 1,
					"k": [{
						"i": {"x": 0.4, "y": 1},
						"o": {"x": 0.333, "y": 0},
						"t": 10,
						"s": [197.494, -316.832, 0],
						"to": [2.814, -2.941, 0],
						"ti": [-2.814, 2.941, 0]
					}, {"t": 30, "s": [214.376, -334.481, 0]}],
					"ix": 2,
					"l": 2
				},
				"a": {"a": 0, "k": [382.294, 676.208, 0], "ix": 1, "l": 2},
				"s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
			},
			"ao": 0,
			"ip": 0,
			"op": 600,
			"st": 0,
			"bm": 0
		}, {
			"ddd": 0,
			"ind": 12,
			"ty": 2,
			"nm": "Layer 5",
			"parent": 13,
			"refId": "image_8",
			"sr": 1,
			"ks": {
				"o": {"a": 0, "k": 100, "ix": 11},
				"r": {"a": 0, "k": 0, "ix": 10},
				"p": {"a": 0, "k": [185.5, -127, 0], "ix": 2, "l": 2},
				"a": {"a": 0, "k": [167.5, 263, 0], "ix": 1, "l": 2},
				"s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
			},
			"ao": 0,
			"ip": 0,
			"op": 600,
			"st": 0,
			"bm": 0
		}, {
			"ddd": 0,
			"ind": 13,
			"ty": 2,
			"nm": "Layer 4",
			"parent": 15,
			"refId": "image_9",
			"sr": 1,
			"ks": {
				"o": {"a": 0, "k": 100, "ix": 11},
				"r": {
					"a": 1,
					"k": [{
						"i": {"x": [0.4], "y": [1]},
						"o": {"x": [0.333], "y": [0]},
						"t": 10,
						"s": [136.058]
					}, {"t": 30, "s": [23.381]}],
					"ix": 10
				},
				"p": {
					"a": 1,
					"k": [{
						"i": {"x": 0.4, "y": 0.4},
						"o": {"x": 0.333, "y": 0.333},
						"t": 10,
						"s": [566, 209, 0],
						"to": [0, 0, 0],
						"ti": [0, 0, 0]
					}, {"t": 30, "s": [566, 209, 0]}],
					"ix": 2,
					"l": 2
				},
				"a": {"a": 0, "k": [129.006, 203.066, 0], "ix": 1, "l": 2},
				"s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
			},
			"ao": 0,
			"ip": 0,
			"op": 600,
			"st": 0,
			"bm": 0
		}, {
			"ddd": 0,
			"ind": 14,
			"ty": 2,
			"nm": "beard",
			"parent": 16,
			"refId": "image_10",
			"sr": 1,
			"ks": {
				"o": {"a": 0, "k": 100, "ix": 11},
				"r": {"a": 0, "k": 0, "ix": 10},
				"p": {"a": 0, "k": [257, 400, 0], "ix": 2, "l": 2},
				"a": {"a": 0, "k": [1024, 1024, 0], "ix": 1, "l": 2},
				"s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
			},
			"ao": 0,
			"ip": 0,
			"op": 600,
			"st": 0,
			"bm": 0
		}, {
			"ddd": 0,
			"ind": 15,
			"ty": 2,
			"nm": "jacket",
			"refId": "image_11",
			"sr": 1,
			"ks": {
				"o": {"a": 0, "k": 100, "ix": 11},
				"r": {
					"a": 1,
					"k": [{"i": {"x": [0.4], "y": [1]}, "o": {"x": [0.333], "y": [0]}, "t": 0, "s": [-17]}, {
						"t": 20,
						"s": [0]
					}],
					"ix": 10
				},
				"p": {
					"a": 1,
					"k": [{
						"i": {"x": 0.4, "y": 1},
						"o": {"x": 0.333, "y": 0},
						"t": 0,
						"s": [1058, 2854, 0],
						"to": [0, -233.333, 0],
						"ti": [0, 46.667, 0]
					}, {"t": 20, "s": [1058, 1454, 0]}],
					"ix": 2,
					"l": 2
				},
				"a": {"a": 0, "k": [353, 412, 0], "ix": 1, "l": 2},
				"s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
			},
			"ao": 0,
			"ip": 0,
			"op": 600,
			"st": 0,
			"bm": 0
		}, {
			"ddd": 0,
			"ind": 16,
			"ty": 2,
			"nm": "skin face",
			"parent": 15,
			"refId": "image_12",
			"sr": 1,
			"ks": {
				"o": {"a": 0, "k": 100, "ix": 11},
				"r": {
					"a": 1,
					"k": [{"i": {"x": [0.4], "y": [1]}, "o": {"x": [0.333], "y": [0]}, "t": 10, "s": [-10]}, {
						"t": 30,
						"s": [0]
					}],
					"ix": 10
				},
				"p": {
					"a": 1,
					"k": [{
						"i": {"x": 0.4, "y": 0.4},
						"o": {"x": 0.333, "y": 0.333},
						"t": 10,
						"s": [343.225, 35.838, 0],
						"to": [0, 0, 0],
						"ti": [0, 0, 0]
					}, {"t": 30, "s": [343.225, 35.838, 0]}],
					"ix": 2,
					"l": 2
				},
				"a": {"a": 0, "k": [281.225, 453.838, 0], "ix": 1, "l": 2},
				"s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
			},
			"ao": 0,
			"ip": 0,
			"op": 600,
			"st": 0,
			"bm": 0
		}]
	}],
	"layers": [{
		"ddd": 0,
		"ind": 1,
		"ty": 4,
		"nm": "Layer 27 Outlines",
		"sr": 1,
		"ks": {
			"o": {
				"a": 1,
				"k": [{
					"i": {"x": [0.667], "y": [1]},
					"o": {"x": [0.333], "y": [0]},
					"t": 84,
					"s": [0]
				}, {
					"i": {"x": [0.667], "y": [1]},
					"o": {"x": [0.333], "y": [0]},
					"t": 100,
					"s": [100]
				}, {"i": {"x": [0.667], "y": [1]}, "o": {"x": [0.333], "y": [0]}, "t": 281, "s": [100]}, {
					"t": 301,
					"s": [0]
				}],
				"ix": 11
			},
			"r": {"a": 0, "k": 0, "ix": 10},
			"p": {"a": 0, "k": [144.559, 629.104, 0], "ix": 2, "l": 2},
			"a": {"a": 0, "k": [13.048, 13.5, 0], "ix": 1, "l": 2},
			"s": {"a": 0, "k": [110, 110, 100], "ix": 6, "l": 2}
		},
		"ao": 0,
		"shapes": [{
			"ty": "gr",
			"it": [{
				"ind": 0,
				"ty": "sh",
				"ix": 1,
				"ks": {
					"a": 0,
					"k": {
						"i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
						"o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
						"v": [[-32.93, 13.201], [-40.57, 13.201], [-48.77, -1.081], [-50.77, -5.081], [-50.811, -5.081], [-50.65, -0.121], [-50.65, 13.201], [-56.73, 13.201], [-56.73, -13.201], [-49.09, -13.201], [-40.891, 1.081], [-38.891, 5.081], [-38.85, 5.081], [-39.01, 0.121], [-39.01, -13.201], [-32.93, -13.201]],
						"c": true
					},
					"ix": 2
				},
				"nm": "Path 5",
				"mn": "ADBE Vector Shape - Group",
				"hd": false
			}, {
				"ty": "fl",
				"c": {"a": 0, "k": [1, 1, 1, 1], "ix": 4},
				"o": {"a": 0, "k": 100, "ix": 5},
				"r": 1,
				"bm": 0,
				"nm": "Fill 1",
				"mn": "ADBE Vector Graphic - Fill",
				"hd": false
			}, {
				"ty": "tr",
				"p": {"a": 0, "k": [56.98, 13.451], "ix": 2},
				"a": {"a": 0, "k": [0, 0], "ix": 1},
				"s": {"a": 0, "k": [100, 100], "ix": 3},
				"r": {"a": 0, "k": 0, "ix": 6},
				"o": {"a": 0, "k": 100, "ix": 7},
				"sk": {"a": 0, "k": 0, "ix": 4},
				"sa": {"a": 0, "k": 0, "ix": 5},
				"nm": "Transform"
			}],
			"nm": "Group 1",
			"np": 2,
			"cix": 2,
			"bm": 0,
			"ix": 1,
			"mn": "ADBE Vector Group",
			"hd": false
		}],
		"ip": 84,
		"op": 302,
		"st": 84,
		"bm": 0
	}, {
		"ddd": 0,
		"ind": 2,
		"ty": 4,
		"nm": "Layer 26 Outlines",
		"sr": 1,
		"ks": {
			"o": {
				"a": 1,
				"k": [{
					"i": {"x": [0.667], "y": [1]},
					"o": {"x": [0.333], "y": [0]},
					"t": 94,
					"s": [0]
				}, {
					"i": {"x": [0.667], "y": [1]},
					"o": {"x": [0.333], "y": [0]},
					"t": 110,
					"s": [100]
				}, {"i": {"x": [0.667], "y": [1]}, "o": {"x": [0.333], "y": [0]}, "t": 281, "s": [100]}, {
					"t": 301,
					"s": [0]
				}],
				"ix": 11
			},
			"r": {"a": 0, "k": 0, "ix": 10},
			"p": {"a": 0, "k": [178.437, 629.104, 0], "ix": 2, "l": 2},
			"a": {"a": 0, "k": [43.846, 13.5, 0], "ix": 1, "l": 2},
			"s": {"a": 0, "k": [110, 110, 100], "ix": 6, "l": 2}
		},
		"ao": 0,
		"shapes": [{
			"ty": "gr",
			"it": [{
				"ind": 0,
				"ty": "sh",
				"ix": 1,
				"ks": {
					"a": 0,
					"k": {
						"i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
						"o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
						"v": [[-2.001, 7.879], [-2.001, 13.201], [-23.081, 13.201], [-23.081, -13.201], [-2.521, -13.201], [-2.521, -7.879], [-16.201, -7.879], [-16.201, -2.52], [-5.322, -2.52], [-5.322, 2.48], [-16.201, 2.48], [-16.201, 7.879]],
						"c": true
					},
					"ix": 2
				},
				"nm": "Path 4",
				"mn": "ADBE Vector Shape - Group",
				"hd": false
			}, {
				"ty": "fl",
				"c": {"a": 0, "k": [1, 1, 1, 1], "ix": 4},
				"o": {"a": 0, "k": 100, "ix": 5},
				"r": 1,
				"bm": 0,
				"nm": "Fill 1",
				"mn": "ADBE Vector Graphic - Fill",
				"hd": false
			}, {
				"ty": "tr",
				"p": {"a": 0, "k": [56.98, 13.451], "ix": 2},
				"a": {"a": 0, "k": [0, 0], "ix": 1},
				"s": {"a": 0, "k": [100, 100], "ix": 3},
				"r": {"a": 0, "k": 0, "ix": 6},
				"o": {"a": 0, "k": 100, "ix": 7},
				"sk": {"a": 0, "k": 0, "ix": 4},
				"sa": {"a": 0, "k": 0, "ix": 5},
				"nm": "Transform"
			}],
			"nm": "Group 1",
			"np": 2,
			"cix": 2,
			"bm": 0,
			"ix": 1,
			"mn": "ADBE Vector Group",
			"hd": false
		}],
		"ip": 94,
		"op": 302,
		"st": 84,
		"bm": 0
	}, {
		"ddd": 0,
		"ind": 3,
		"ty": 4,
		"nm": "Layer 25 Outlines",
		"sr": 1,
		"ks": {
			"o": {
				"a": 1,
				"k": [{
					"i": {"x": [0.667], "y": [1]},
					"o": {"x": [0.333], "y": [0]},
					"t": 104,
					"s": [0]
				}, {
					"i": {"x": [0.667], "y": [1]},
					"o": {"x": [0.333], "y": [0]},
					"t": 120,
					"s": [100]
				}, {"i": {"x": [0.667], "y": [1]}, "o": {"x": [0.333], "y": [0]}, "t": 281, "s": [100]}, {
					"t": 301,
					"s": [0]
				}],
				"ix": 11
			},
			"r": {"a": 0, "k": 0, "ix": 10},
			"p": {"a": 0, "k": [210.062, 629.104, 0], "ix": 2, "l": 2},
			"a": {"a": 0, "k": [72.596, 13.5, 0], "ix": 1, "l": 2},
			"s": {"a": 0, "k": [110, 110, 100], "ix": 6, "l": 2}
		},
		"ao": 0,
		"shapes": [{
			"ty": "gr",
			"it": [{
				"ind": 0,
				"ty": "sh",
				"ix": 1,
				"ks": {
					"a": 0,
					"k": {
						"i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
						"o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
						"v": [[28.352, -7.879], [19.753, -7.879], [19.753, 13.201], [12.872, 13.201], [12.872, -7.879], [4.232, -7.879], [4.232, -13.201], [28.352, -13.201]],
						"c": true
					},
					"ix": 2
				},
				"nm": "Path 3",
				"mn": "ADBE Vector Shape - Group",
				"hd": false
			}, {
				"ty": "fl",
				"c": {"a": 0, "k": [1, 1, 1, 1], "ix": 4},
				"o": {"a": 0, "k": 100, "ix": 5},
				"r": 1,
				"bm": 0,
				"nm": "Fill 1",
				"mn": "ADBE Vector Graphic - Fill",
				"hd": false
			}, {
				"ty": "tr",
				"p": {"a": 0, "k": [56.98, 13.451], "ix": 2},
				"a": {"a": 0, "k": [0, 0], "ix": 1},
				"s": {"a": 0, "k": [100, 100], "ix": 3},
				"r": {"a": 0, "k": 0, "ix": 6},
				"o": {"a": 0, "k": 100, "ix": 7},
				"sk": {"a": 0, "k": 0, "ix": 4},
				"sa": {"a": 0, "k": 0, "ix": 5},
				"nm": "Transform"
			}],
			"nm": "Group 1",
			"np": 2,
			"cix": 2,
			"bm": 0,
			"ix": 1,
			"mn": "ADBE Vector Group",
			"hd": false
		}],
		"ip": 104,
		"op": 302,
		"st": 84,
		"bm": 0
	}, {
		"ddd": 0,
		"ind": 4,
		"ty": 4,
		"nm": "Layer 24 Outlines",
		"sr": 1,
		"ks": {
			"o": {
				"a": 1,
				"k": [{
					"i": {"x": [0.667], "y": [1]},
					"o": {"x": [0.333], "y": [0]},
					"t": 114,
					"s": [0]
				}, {
					"i": {"x": [0.667], "y": [1]},
					"o": {"x": [0.333], "y": [0]},
					"t": 130,
					"s": [100]
				}, {"i": {"x": [0.667], "y": [1]}, "o": {"x": [0.333], "y": [0]}, "t": 281, "s": [100]}, {
					"t": 301,
					"s": [0]
				}],
				"ix": 11
			},
			"r": {"a": 0, "k": 0, "ix": 10},
			"p": {"a": 0, "k": [239.984, 629.104, 0], "ix": 2, "l": 2},
			"a": {"a": 0, "k": [99.798, 13.5, 0], "ix": 1, "l": 2},
			"s": {"a": 0, "k": [110, 110, 100], "ix": 6, "l": 2}
		},
		"ao": 0,
		"shapes": [{
			"ty": "gr",
			"it": [{
				"ind": 0,
				"ty": "sh",
				"ix": 1,
				"ks": {
					"a": 0,
					"k": {
						"i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
						"o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
						"v": [[46.411, 2.56], [44.49, -3.759], [43.331, -7.919], [43.251, -7.919], [42.171, -3.799], [40.171, 2.56]],
						"c": true
					},
					"ix": 2
				},
				"nm": "Path 1",
				"mn": "ADBE Vector Shape - Group",
				"hd": false
			}, {
				"ind": 1,
				"ty": "sh",
				"ix": 2,
				"ks": {
					"a": 0,
					"k": {
						"i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
						"o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
						"v": [[47.85, 7.241], [38.73, 7.241], [36.891, 13.201], [29.971, 13.201], [39.251, -13.201], [47.49, -13.201], [56.73, 13.201], [49.65, 13.201]],
						"c": true
					},
					"ix": 2
				},
				"nm": "Path 2",
				"mn": "ADBE Vector Shape - Group",
				"hd": false
			}, {
				"ty": "fl",
				"c": {"a": 0, "k": [1, 1, 1, 1], "ix": 4},
				"o": {"a": 0, "k": 100, "ix": 5},
				"r": 1,
				"bm": 0,
				"nm": "Fill 1",
				"mn": "ADBE Vector Graphic - Fill",
				"hd": false
			}, {
				"ty": "tr",
				"p": {"a": 0, "k": [56.98, 13.451], "ix": 2},
				"a": {"a": 0, "k": [0, 0], "ix": 1},
				"s": {"a": 0, "k": [100, 100], "ix": 3},
				"r": {"a": 0, "k": 0, "ix": 6},
				"o": {"a": 0, "k": 100, "ix": 7},
				"sk": {"a": 0, "k": 0, "ix": 4},
				"sa": {"a": 0, "k": 0, "ix": 5},
				"nm": "Transform"
			}],
			"nm": "Group 1",
			"np": 3,
			"cix": 2,
			"bm": 0,
			"ix": 1,
			"mn": "ADBE Vector Group",
			"hd": false
		}],
		"ip": 114,
		"op": 302,
		"st": 84,
		"bm": 0
	}, {
		"ddd": 0,
		"ind": 5,
		"ty": 4,
		"nm": "Layer 15 Outlines",
		"sr": 1,
		"ks": {
			"o": {"a": 0, "k": 100, "ix": 11},
			"r": {"a": 0, "k": 0, "ix": 10},
			"p": {"a": 0, "k": [297.5, 327, 0], "ix": 2, "l": 2},
			"a": {"a": 0, "k": [7.25, 7.25, 0], "ix": 1, "l": 2},
			"s": {
				"a": 1,
				"k": [{
					"i": {"x": [0.667, 0.667, 0.667], "y": [1, 1, 1]},
					"o": {"x": [0.333, 0.333, 0.333], "y": [0, 0, 0]},
					"t": 51,
					"s": [0, 0, 100]
				}, {"t": 61, "s": [100, 100, 100]}],
				"ix": 6,
				"l": 2
			}
		},
		"ao": 0,
		"shapes": [{
			"ty": "gr",
			"it": [{
				"ind": 0,
				"ty": "sh",
				"ix": 1,
				"ks": {
					"a": 0,
					"k": {
						"i": [[0, -3.862], [3.862, 0], [0, 3.862], [-3.862, 0]],
						"o": [[0, 3.862], [-3.862, 0], [0, -3.862], [3.862, 0]],
						"v": [[7, 0], [0, 7], [-7, 0], [0, -7]],
						"c": true
					},
					"ix": 2
				},
				"nm": "Path 1",
				"mn": "ADBE Vector Shape - Group",
				"hd": false
			}, {
				"ty": "fl",
				"c": {"a": 0, "k": [0.117647066303, 0.933333393172, 0.776470648074, 1], "ix": 4},
				"o": {"a": 0, "k": 100, "ix": 5},
				"r": 1,
				"bm": 0,
				"nm": "Fill 1",
				"mn": "ADBE Vector Graphic - Fill",
				"hd": false
			}, {
				"ty": "tr",
				"p": {"a": 0, "k": [7.25, 7.25], "ix": 2},
				"a": {"a": 0, "k": [0, 0], "ix": 1},
				"s": {"a": 0, "k": [100, 100], "ix": 3},
				"r": {"a": 0, "k": 0, "ix": 6},
				"o": {"a": 0, "k": 100, "ix": 7},
				"sk": {"a": 0, "k": 0, "ix": 4},
				"sa": {"a": 0, "k": 0, "ix": 5},
				"nm": "Transform"
			}],
			"nm": "Group 1",
			"np": 4,
			"cix": 2,
			"bm": 0,
			"ix": 1,
			"mn": "ADBE Vector Group",
			"hd": false
		}],
		"ip": 51,
		"op": 771,
		"st": 51,
		"bm": 0
	}, {
		"ddd": 0,
		"ind": 6,
		"ty": 4,
		"nm": "Layer 16 Outlines",
		"sr": 1,
		"ks": {
			"o": {"a": 0, "k": 100, "ix": 11},
			"r": {"a": 0, "k": 0, "ix": 10},
			"p": {"a": 0, "k": [126.5, 454, 0], "ix": 2, "l": 2},
			"a": {"a": 0, "k": [7.25, 7.25, 0], "ix": 1, "l": 2},
			"s": {
				"a": 1,
				"k": [{
					"i": {"x": [0.667, 0.667, 0.667], "y": [1, 1, 1]},
					"o": {"x": [0.333, 0.333, 0.333], "y": [0, 0, 0]},
					"t": 27,
					"s": [0, 0, 100]
				}, {"t": 37, "s": [100, 100, 100]}],
				"ix": 6,
				"l": 2
			}
		},
		"ao": 0,
		"shapes": [{
			"ty": "gr",
			"it": [{
				"ind": 0,
				"ty": "sh",
				"ix": 1,
				"ks": {
					"a": 0,
					"k": {
						"i": [[0, -3.862], [3.862, 0], [0, 3.862], [-3.862, 0]],
						"o": [[0, 3.862], [-3.862, 0], [0, -3.862], [3.862, 0]],
						"v": [[7, 0], [0, 7], [-7, 0], [0, -7]],
						"c": true
					},
					"ix": 2
				},
				"nm": "Path 1",
				"mn": "ADBE Vector Shape - Group",
				"hd": false
			}, {
				"ty": "fl",
				"c": {"a": 0, "k": [0.996078491211, 0.301960784314, 0.301960784314, 1], "ix": 4},
				"o": {"a": 0, "k": 100, "ix": 5},
				"r": 1,
				"bm": 0,
				"nm": "Fill 1",
				"mn": "ADBE Vector Graphic - Fill",
				"hd": false
			}, {
				"ty": "tr",
				"p": {"a": 0, "k": [7.25, 7.25], "ix": 2},
				"a": {"a": 0, "k": [0, 0], "ix": 1},
				"s": {"a": 0, "k": [100, 100], "ix": 3},
				"r": {"a": 0, "k": 0, "ix": 6},
				"o": {"a": 0, "k": 100, "ix": 7},
				"sk": {"a": 0, "k": 0, "ix": 4},
				"sa": {"a": 0, "k": 0, "ix": 5},
				"nm": "Transform"
			}],
			"nm": "Group 1",
			"np": 4,
			"cix": 2,
			"bm": 0,
			"ix": 1,
			"mn": "ADBE Vector Group",
			"hd": false
		}],
		"ip": 27,
		"op": 747,
		"st": 27,
		"bm": 0
	}, {
		"ddd": 0,
		"ind": 7,
		"ty": 4,
		"nm": "Layer 21 Outlines 5",
		"sr": 1,
		"ks": {
			"o": {"a": 0, "k": 100, "ix": 11},
			"r": {"a": 0, "k": 0, "ix": 10},
			"p": {"a": 0, "k": [222.375, 502, 0], "ix": 2, "l": 2},
			"a": {"a": 0, "k": [0.5, 76, 0], "ix": 1, "l": 2},
			"s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
		},
		"ao": 0,
		"shapes": [{
			"ty": "gr",
			"it": [{
				"ind": 0,
				"ty": "sh",
				"ix": 1,
				"ks": {
					"a": 0,
					"k": {"i": [[0, 0], [0, 0]], "o": [[0, 0], [0, 0]], "v": [[0.5, 0], [0.5, 152]], "c": false},
					"ix": 2
				},
				"nm": "Path 1",
				"mn": "ADBE Vector Shape - Group",
				"hd": false
			}, {
				"ty": "gs",
				"o": {"a": 0, "k": 100, "ix": 9},
				"w": {"a": 0, "k": 0.5, "ix": 10},
				"g": {
					"p": 3,
					"k": {
						"a": 0,
						"k": [0, 1, 1, 1, 0.5, 0.82, 0.755, 0.986, 1, 0.639, 0.51, 0.973, 0, 1, 0.855, 0.5, 1, 0],
						"ix": 8
					}
				},
				"s": {"a": 0, "k": [0, 0], "ix": 4},
				"e": {"a": 0, "k": [0, 154], "ix": 5},
				"t": 1,
				"lc": 1,
				"lj": 1,
				"ml": 4,
				"ml2": {"a": 0, "k": 4, "ix": 13},
				"bm": 0,
				"d": [{"n": "d", "nm": "dash", "v": {"a": 0, "k": 10, "ix": 1}}, {
					"n": "g",
					"nm": "gap",
					"v": {"a": 0, "k": 8, "ix": 2}
				}, {"n": "o", "nm": "offset", "v": {"a": 0, "k": 6, "ix": 7}}],
				"nm": "Gradient Stroke 1",
				"mn": "ADBE Vector Graphic - G-Stroke",
				"hd": false
			}, {
				"ty": "tr",
				"p": {"a": 0, "k": [0, 0], "ix": 2},
				"a": {"a": 0, "k": [0, 0], "ix": 1},
				"s": {"a": 0, "k": [100, 100], "ix": 3},
				"r": {"a": 0, "k": 0, "ix": 6},
				"o": {"a": 0, "k": 100, "ix": 7},
				"sk": {"a": 0, "k": 0, "ix": 4},
				"sa": {"a": 0, "k": 0, "ix": 5},
				"nm": "Transform"
			}],
			"nm": "Group 1",
			"np": 2,
			"cix": 2,
			"bm": 0,
			"ix": 1,
			"mn": "ADBE Vector Group",
			"hd": false
		}, {
			"ty": "tm",
			"s": {"a": 0, "k": 0, "ix": 1},
			"e": {
				"a": 1,
				"k": [{"i": {"x": [0.667], "y": [1]}, "o": {"x": [0.333], "y": [0]}, "t": 36, "s": [0]}, {
					"t": 53,
					"s": [100]
				}],
				"ix": 2
			},
			"o": {"a": 0, "k": 0, "ix": 3},
			"m": 1,
			"ix": 2,
			"nm": "Trim Paths 1",
			"mn": "ADBE Vector Filter - Trim",
			"hd": false
		}],
		"ip": 36,
		"op": 756,
		"st": 36,
		"bm": 0
	}, {
		"ddd": 0,
		"ind": 8,
		"ty": 4,
		"nm": "Layer 21 Outlines 4",
		"sr": 1,
		"ks": {
			"o": {"a": 0, "k": 100, "ix": 11},
			"r": {"a": 0, "k": 0, "ix": 10},
			"p": {"a": 0, "k": [222.375, 502, 0], "ix": 2, "l": 2},
			"a": {"a": 0, "k": [0.5, 76, 0], "ix": 1, "l": 2},
			"s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
		},
		"ao": 0,
		"shapes": [{
			"ty": "gr",
			"it": [{
				"ind": 0,
				"ty": "sh",
				"ix": 1,
				"ks": {
					"a": 0,
					"k": {"i": [[0, 0], [0, 0]], "o": [[0, 0], [0, 0]], "v": [[0.5, 0], [0.5, 152]], "c": false},
					"ix": 2
				},
				"nm": "Path 1",
				"mn": "ADBE Vector Shape - Group",
				"hd": false
			}, {
				"ty": "gs",
				"o": {"a": 0, "k": 100, "ix": 9},
				"w": {"a": 0, "k": 0.5, "ix": 10},
				"g": {
					"p": 3,
					"k": {
						"a": 0,
						"k": [0, 1, 1, 1, 0.5, 0.82, 0.755, 0.986, 1, 0.639, 0.51, 0.973, 0, 1, 0.855, 0.5, 1, 0],
						"ix": 8
					}
				},
				"s": {"a": 0, "k": [0, 0], "ix": 4},
				"e": {"a": 0, "k": [0, 154], "ix": 5},
				"t": 1,
				"lc": 1,
				"lj": 1,
				"ml": 4,
				"ml2": {"a": 0, "k": 4, "ix": 13},
				"bm": 0,
				"d": [{"n": "d", "nm": "dash", "v": {"a": 0, "k": 10, "ix": 1}}, {
					"n": "g",
					"nm": "gap",
					"v": {"a": 0, "k": 8, "ix": 2}
				}, {"n": "o", "nm": "offset", "v": {"a": 0, "k": 6, "ix": 7}}],
				"nm": "Gradient Stroke 1",
				"mn": "ADBE Vector Graphic - G-Stroke",
				"hd": false
			}, {
				"ty": "tr",
				"p": {"a": 0, "k": [0, 0], "ix": 2},
				"a": {"a": 0, "k": [0, 0], "ix": 1},
				"s": {"a": 0, "k": [100, 100], "ix": 3},
				"r": {"a": 0, "k": 0, "ix": 6},
				"o": {"a": 0, "k": 100, "ix": 7},
				"sk": {"a": 0, "k": 0, "ix": 4},
				"sa": {"a": 0, "k": 0, "ix": 5},
				"nm": "Transform"
			}],
			"nm": "Group 1",
			"np": 2,
			"cix": 2,
			"bm": 0,
			"ix": 1,
			"mn": "ADBE Vector Group",
			"hd": false
		}, {
			"ty": "tm",
			"s": {"a": 0, "k": 0, "ix": 1},
			"e": {
				"a": 1,
				"k": [{"i": {"x": [0.667], "y": [1]}, "o": {"x": [0.333], "y": [0]}, "t": 37, "s": [0]}, {
					"t": 54,
					"s": [100]
				}],
				"ix": 2
			},
			"o": {"a": 0, "k": 0, "ix": 3},
			"m": 1,
			"ix": 2,
			"nm": "Trim Paths 1",
			"mn": "ADBE Vector Filter - Trim",
			"hd": false
		}],
		"ip": 37,
		"op": 757,
		"st": 37,
		"bm": 0
	}, {
		"ddd": 0,
		"ind": 9,
		"ty": 4,
		"nm": "Layer 21 Outlines 3",
		"sr": 1,
		"ks": {
			"o": {"a": 0, "k": 100, "ix": 11},
			"r": {"a": 0, "k": 0, "ix": 10},
			"p": {"a": 0, "k": [297.625, 405, 0], "ix": 2, "l": 2},
			"a": {"a": 0, "k": [0.5, 76, 0], "ix": 1, "l": 2},
			"s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
		},
		"ao": 0,
		"shapes": [{
			"ty": "gr",
			"it": [{
				"ind": 0,
				"ty": "sh",
				"ix": 1,
				"ks": {
					"a": 0,
					"k": {"i": [[0, 0], [0, 0]], "o": [[0, 0], [0, 0]], "v": [[0.5, 0], [0.5, 152]], "c": false},
					"ix": 2
				},
				"nm": "Path 1",
				"mn": "ADBE Vector Shape - Group",
				"hd": false
			}, {
				"ty": "gs",
				"o": {"a": 0, "k": 100, "ix": 9},
				"w": {"a": 0, "k": 0.5, "ix": 10},
				"g": {
					"p": 3,
					"k": {
						"a": 0,
						"k": [0, 1, 1, 1, 0.5, 0.82, 0.755, 0.986, 1, 0.639, 0.51, 0.973, 0, 1, 0.855, 0.5, 1, 0],
						"ix": 8
					}
				},
				"s": {"a": 0, "k": [0, 0], "ix": 4},
				"e": {"a": 0, "k": [0, 154], "ix": 5},
				"t": 1,
				"lc": 1,
				"lj": 1,
				"ml": 4,
				"ml2": {"a": 0, "k": 4, "ix": 13},
				"bm": 0,
				"d": [{"n": "d", "nm": "dash", "v": {"a": 0, "k": 10, "ix": 1}}, {
					"n": "g",
					"nm": "gap",
					"v": {"a": 0, "k": 8, "ix": 2}
				}, {"n": "o", "nm": "offset", "v": {"a": 0, "k": 6, "ix": 7}}],
				"nm": "Gradient Stroke 1",
				"mn": "ADBE Vector Graphic - G-Stroke",
				"hd": false
			}, {
				"ty": "tr",
				"p": {"a": 0, "k": [0, 0], "ix": 2},
				"a": {"a": 0, "k": [0, 0], "ix": 1},
				"s": {"a": 0, "k": [100, 100], "ix": 3},
				"r": {"a": 0, "k": 0, "ix": 6},
				"o": {"a": 0, "k": 100, "ix": 7},
				"sk": {"a": 0, "k": 0, "ix": 4},
				"sa": {"a": 0, "k": 0, "ix": 5},
				"nm": "Transform"
			}],
			"nm": "Group 1",
			"np": 2,
			"cix": 2,
			"bm": 0,
			"ix": 1,
			"mn": "ADBE Vector Group",
			"hd": false
		}, {
			"ty": "tm",
			"s": {"a": 0, "k": 0, "ix": 1},
			"e": {
				"a": 1,
				"k": [{"i": {"x": [0.4], "y": [1]}, "o": {"x": [0.333], "y": [0]}, "t": 50, "s": [0]}, {
					"t": 67,
					"s": [100]
				}],
				"ix": 2
			},
			"o": {"a": 0, "k": 0, "ix": 3},
			"m": 1,
			"ix": 2,
			"nm": "Trim Paths 1",
			"mn": "ADBE Vector Filter - Trim",
			"hd": false
		}],
		"ip": 50,
		"op": 770,
		"st": 50,
		"bm": 0
	}, {
		"ddd": 0,
		"ind": 10,
		"ty": 4,
		"nm": "Layer 21 Outlines",
		"sr": 1,
		"ks": {
			"o": {
				"a": 1,
				"k": [{"i": {"x": [0.4], "y": [1]}, "o": {"x": [0.6], "y": [0]}, "t": 26, "s": [0]}, {
					"t": 36,
					"s": [100]
				}],
				"ix": 11
			},
			"r": {"a": 0, "k": 0, "ix": 10},
			"p": {"a": 0, "k": [126, 530, 0], "ix": 2, "l": 2},
			"a": {"a": 0, "k": [0.5, 76, 0], "ix": 1, "l": 2},
			"s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
		},
		"ao": 0,
		"shapes": [{
			"ty": "gr",
			"it": [{
				"ind": 0,
				"ty": "sh",
				"ix": 1,
				"ks": {
					"a": 0,
					"k": {"i": [[0, 0], [0, 0]], "o": [[0, 0], [0, 0]], "v": [[0.5, 0], [0.5, 152]], "c": false},
					"ix": 2
				},
				"nm": "Path 1",
				"mn": "ADBE Vector Shape - Group",
				"hd": false
			}, {
				"ty": "gs",
				"o": {"a": 0, "k": 100, "ix": 9},
				"w": {"a": 0, "k": 0.5, "ix": 10},
				"g": {
					"p": 3,
					"k": {
						"a": 0,
						"k": [0, 1, 1, 1, 0.5, 0.82, 0.755, 0.986, 1, 0.639, 0.51, 0.973, 0, 1, 0.855, 0.5, 1, 0],
						"ix": 8
					}
				},
				"s": {"a": 0, "k": [0, 0], "ix": 4},
				"e": {"a": 0, "k": [0, 154], "ix": 5},
				"t": 1,
				"lc": 1,
				"lj": 1,
				"ml": 4,
				"ml2": {"a": 0, "k": 4, "ix": 13},
				"bm": 0,
				"d": [{"n": "d", "nm": "dash", "v": {"a": 0, "k": 10, "ix": 1}}, {
					"n": "g",
					"nm": "gap",
					"v": {"a": 0, "k": 8, "ix": 2}
				}, {"n": "o", "nm": "offset", "v": {"a": 0, "k": 6, "ix": 7}}],
				"nm": "Gradient Stroke 1",
				"mn": "ADBE Vector Graphic - G-Stroke",
				"hd": false
			}, {
				"ty": "tr",
				"p": {"a": 0, "k": [0, 0], "ix": 2},
				"a": {"a": 0, "k": [0, 0], "ix": 1},
				"s": {"a": 0, "k": [100, 100], "ix": 3},
				"r": {"a": 0, "k": 0, "ix": 6},
				"o": {"a": 0, "k": 100, "ix": 7},
				"sk": {"a": 0, "k": 0, "ix": 4},
				"sa": {"a": 0, "k": 0, "ix": 5},
				"nm": "Transform"
			}],
			"nm": "Group 1",
			"np": 2,
			"cix": 2,
			"bm": 0,
			"ix": 1,
			"mn": "ADBE Vector Group",
			"hd": false
		}],
		"ip": 26,
		"op": 746,
		"st": 26,
		"bm": 0
	}, {
		"ddd": 0,
		"ind": 11,
		"ty": 4,
		"nm": "Layer 1 Outlines",
		"sr": 1,
		"ks": {
			"o": {"a": 0, "k": 100, "ix": 11},
			"r": {"a": 0, "k": 0, "ix": 10},
			"p": {"a": 0, "k": [188.888, 402.303, 0], "ix": 2, "l": 2},
			"a": {"a": 0, "k": [193.164, 102.911, 0], "ix": 1, "l": 2},
			"s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
		},
		"ao": 0,
		"shapes": [{
			"ty": "gr",
			"it": [{
				"ind": 0,
				"ty": "sh",
				"ix": 1,
				"ks": {
					"a": 0,
					"k": {
						"i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
						"o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
						"v": [[-192.226, 101.194], [-107.274, 28.577], [-60.995, 52.483], [-19.997, 25.572], [31.454, 23.875], [106.604, -75.396], [192.225, -101.194]],
						"c": false
					},
					"ix": 2
				},
				"nm": "Path 1",
				"mn": "ADBE Vector Shape - Group",
				"hd": false
			}, {
				"ty": "st",
				"c": {"a": 0, "k": [1, 1, 1, 1], "ix": 3},
				"o": {"a": 0, "k": 100, "ix": 4},
				"w": {"a": 0, "k": 4, "ix": 5},
				"lc": 2,
				"lj": 2,
				"bm": 0,
				"nm": "Stroke 1",
				"mn": "ADBE Vector Graphic - Stroke",
				"hd": false
			}, {
				"ty": "tr",
				"p": {"a": 0, "k": [193.525, 103.109], "ix": 2},
				"a": {"a": 0, "k": [0, 0], "ix": 1},
				"s": {"a": 0, "k": [100, 100], "ix": 3},
				"r": {"a": 0, "k": 0, "ix": 6},
				"o": {"a": 0, "k": 100, "ix": 7},
				"sk": {"a": 0, "k": 0, "ix": 4},
				"sa": {"a": 0, "k": 0, "ix": 5},
				"nm": "Transform"
			}],
			"nm": "Group 1",
			"np": 2,
			"cix": 2,
			"bm": 0,
			"ix": 1,
			"mn": "ADBE Vector Group",
			"hd": false
		}, {
			"ty": "tm",
			"s": {"a": 0, "k": 0, "ix": 1},
			"e": {
				"a": 1,
				"k": [{"i": {"x": [0.667], "y": [1]}, "o": {"x": [0.333], "y": [0]}, "t": 0, "s": [0]}, {
					"t": 70,
					"s": [100]
				}],
				"ix": 2
			},
			"o": {"a": 0, "k": 0, "ix": 3},
			"m": 1,
			"ix": 2,
			"nm": "Trim Paths 1",
			"mn": "ADBE Vector Filter - Trim",
			"hd": false
		}],
		"ip": 0,
		"op": 720,
		"st": 0,
		"bm": 0
	}, {
		"ddd": 0,
		"ind": 12,
		"ty": 4,
		"nm": "Shape Layer 1",
		"td": 1,
		"sr": 1,
		"ks": {
			"o": {"a": 0, "k": 100, "ix": 11},
			"r": {"a": 0, "k": 0, "ix": 10},
			"p": {"a": 0, "k": [-26.5, 576, 0], "ix": 2, "l": 2},
			"a": {"a": 0, "k": [-215.5, 170, 0], "ix": 1, "l": 2},
			"s": {
				"a": 1,
				"k": [{
					"i": {"x": [0.685, 0.685, 0.685], "y": [0.454, 1, 1]},
					"o": {"x": [0.419, 0.419, 0.419], "y": [0, 0, 0]},
					"t": 0,
					"s": [6.206, 100, 100]
				}, {
					"i": {"x": [0.646, 0.646, 0.646], "y": [0.62, 1, 1]},
					"o": {"x": [0.317, 0.317, 0.317], "y": [0.42, 0, 0]},
					"t": 32,
					"s": [54.999, 100, 100]
				}, {
					"i": {"x": [0.595, 0.595, 0.595], "y": [1, 1, 1]},
					"o": {"x": [0.277, 0.277, 0.277], "y": [0.726, 0, 0]},
					"t": 39,
					"s": [68.933, 100, 100]
				}, {"t": 70, "s": [94.159, 100, 100]}],
				"ix": 6,
				"l": 2
			}
		},
		"ao": 0,
		"shapes": [{
			"ty": "gr",
			"it": [{
				"ty": "rc",
				"d": 1,
				"s": {"a": 0, "k": [428, 556], "ix": 2},
				"p": {"a": 0, "k": [0, 0], "ix": 3},
				"r": {"a": 0, "k": 0, "ix": 4},
				"nm": "Rectangle Path 1",
				"mn": "ADBE Vector Shape - Rect",
				"hd": false
			}, {
				"ty": "st",
				"c": {"a": 0, "k": [0.047058827269, 0.807843197093, 0.666666666667, 1], "ix": 3},
				"o": {"a": 0, "k": 100, "ix": 4},
				"w": {"a": 0, "k": 4, "ix": 5},
				"lc": 1,
				"lj": 1,
				"ml": 4,
				"bm": 0,
				"nm": "Stroke 1",
				"mn": "ADBE Vector Graphic - Stroke",
				"hd": false
			}, {
				"ty": "fl",
				"c": {"a": 0, "k": [0.105881993911, 0.105881993911, 0.105881993911, 1], "ix": 4},
				"o": {"a": 0, "k": 100, "ix": 5},
				"r": 1,
				"bm": 0,
				"nm": "Fill 1",
				"mn": "ADBE Vector Graphic - Fill",
				"hd": false
			}, {
				"ty": "tr",
				"p": {"a": 0, "k": [-1.5, 170], "ix": 2},
				"a": {"a": 0, "k": [0, 0], "ix": 1},
				"s": {"a": 0, "k": [100, 100], "ix": 3},
				"r": {"a": 0, "k": 0, "ix": 6},
				"o": {"a": 0, "k": 100, "ix": 7},
				"sk": {"a": 0, "k": 0, "ix": 4},
				"sa": {"a": 0, "k": 0, "ix": 5},
				"nm": "Transform"
			}],
			"nm": "Rectangle 1",
			"np": 3,
			"cix": 2,
			"bm": 0,
			"ix": 1,
			"mn": "ADBE Vector Group",
			"hd": false
		}],
		"ip": 0,
		"op": 720,
		"st": 0,
		"bm": 0
	}, {
		"ddd": 0,
		"ind": 13,
		"ty": 4,
		"nm": "Layer 18 Outlines",
		"tt": 1,
		"sr": 1,
		"ks": {
			"o": {"a": 0, "k": 100, "ix": 11},
			"r": {"a": 0, "k": 0, "ix": 10},
			"p": {"a": 0, "k": [188, 557.553, 0], "ix": 2, "l": 2},
			"a": {"a": 0, "k": [187.75, 254.697, 0], "ix": 1, "l": 2},
			"s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
		},
		"ao": 0,
		"shapes": [{
			"ty": "gr",
			"it": [{
				"ty": "gr",
				"it": [{
					"ind": 0,
					"ty": "sh",
					"ix": 1,
					"ks": {
						"a": 0,
						"k": {
							"i": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
							"o": [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
							"v": [[107.854, -230.449], [32.703, -131.178], [-18.747, -129.48], [-59.745, -102.569], [-106.025, -126.476], [-187.5, -56.83], [-187.5, 254.447], [187.5, 254.447], [187.5, -254.447]],
							"c": true
						},
						"ix": 2
					},
					"nm": "Path 2",
					"mn": "ADBE Vector Shape - Group",
					"hd": false
				}, {
					"ty": "tr",
					"p": {"a": 0, "k": [0, 0], "ix": 2},
					"a": {"a": 0, "k": [0, 0], "ix": 1},
					"s": {"a": 0, "k": [100, 100], "ix": 3},
					"r": {"a": 0, "k": 0, "ix": 6},
					"o": {"a": 0, "k": 100, "ix": 7},
					"sk": {"a": 0, "k": 0, "ix": 4},
					"sa": {"a": 0, "k": 0, "ix": 5},
					"nm": "Transform"
				}],
				"nm": "Group 1",
				"np": 1,
				"cix": 2,
				"bm": 0,
				"ix": 1,
				"mn": "ADBE Vector Group",
				"hd": false
			}, {
				"ty": "gf",
				"o": {"a": 0, "k": 100, "ix": 10},
				"r": 1,
				"bm": 0,
				"g": {
					"p": 3,
					"k": {
						"a": 0,
						"k": [0, 0.765, 0.678, 0.996, 0.17, 0.663, 0.543, 0.975, 1, 0.561, 0.408, 0.953],
						"ix": 9
					}
				},
				"s": {"a": 0, "k": [-4, -318], "ix": 5},
				"e": {"a": 0, "k": [6, 328], "ix": 6},
				"t": 1,
				"nm": "Gradient Fill 1",
				"mn": "ADBE Vector Graphic - G-Fill",
				"hd": false
			}, {
				"ty": "tr",
				"p": {"a": 0, "k": [187.75, 254.697], "ix": 2},
				"a": {"a": 0, "k": [0, 0], "ix": 1},
				"s": {"a": 0, "k": [100, 100], "ix": 3},
				"r": {"a": 0, "k": 0, "ix": 6},
				"o": {"a": 0, "k": 100, "ix": 7},
				"sk": {"a": 0, "k": 0, "ix": 4},
				"sa": {"a": 0, "k": 0, "ix": 5},
				"nm": "Transform"
			}],
			"nm": "Group 1",
			"np": 2,
			"cix": 2,
			"bm": 0,
			"ix": 1,
			"mn": "ADBE Vector Group",
			"hd": false
		}],
		"ip": 0,
		"op": 720,
		"st": 0,
		"bm": 0
	}, {
		"ddd": 0,
		"ind": 14,
		"ty": 0,
		"nm": "Neta illustration",
		"refId": "comp_0",
		"sr": 1,
		"ks": {
			"o": {"a": 0, "k": 100, "ix": 11},
			"r": {"a": 0, "k": 0, "ix": 10},
			"p": {"a": 0, "k": [177, 330, 0], "ix": 2, "l": 2},
			"a": {"a": 0, "k": [1024, 1024, 0], "ix": 1, "l": 2},
			"s": {"a": 0, "k": [16, 16, 100], "ix": 6, "l": 2}
		},
		"ao": 0,
		"tm": {
			"a": 1,
			"k": [{"i": {"x": [0.833], "y": [0.833]}, "o": {"x": [0.167], "y": [0.167]}, "t": 63, "s": [0]}, {
				"t": 186,
				"s": [1.317]
			}],
			"ix": 2
		},
		"w": 2048,
		"h": 2048,
		"ip": 63,
		"op": 663,
		"st": 63,
		"bm": 0
	}, {
		"ddd": 0,
		"ind": 15,
		"ty": 4,
		"nm": "Layer 12 Outlines",
		"sr": 1,
		"ks": {
			"o": {"a": 0, "k": 100, "ix": 11},
			"r": {
				"a": 1,
				"k": [{
					"i": {"x": [0.667], "y": [1]},
					"o": {"x": [0.333], "y": [0]},
					"t": 95,
					"s": [0]
				}, {"i": {"x": [0.667], "y": [1]}, "o": {"x": [0.333], "y": [0]}, "t": 129, "s": [120]}, {
					"t": 371,
					"s": [255]
				}],
				"ix": 10
			},
			"p": {"a": 0, "k": [91.047, 266.898, 0], "ix": 2, "l": 2},
			"a": {"a": 0, "k": [2.087, 2.086, 0], "ix": 1, "l": 2},
			"s": {
				"a": 1,
				"k": [{
					"i": {"x": [0.667, 0.667, 0.667], "y": [1, 1, 1]},
					"o": {"x": [0.333, 0.333, 0.333], "y": [0, 0, 0]},
					"t": 95,
					"s": [0, 0, 100]
				}, {
					"i": {"x": [0.667, 0.667, 0.667], "y": [1, 1, 1]},
					"o": {"x": [0.333, 0.333, 0.333], "y": [0, 0, 0]},
					"t": 131,
					"s": [100, 100, 100]
				}, {
					"i": {"x": [0.667, 0.667, 0.667], "y": [1, 1, 1]},
					"o": {"x": [0.333, 0.333, 0.333], "y": [0, 0, 0]},
					"t": 161,
					"s": [80, 80, 100]
				}, {
					"i": {"x": [0.667, 0.667, 0.667], "y": [1, 1, 1]},
					"o": {"x": [0.333, 0.333, 0.333], "y": [0, 0, 0]},
					"t": 191,
					"s": [100, 100, 100]
				}, {
					"i": {"x": [0.667, 0.667, 0.667], "y": [1, 1, 1]},
					"o": {"x": [0.333, 0.333, 0.333], "y": [0, 0, 0]},
					"t": 221,
					"s": [80, 80, 100]
				}, {
					"i": {"x": [0.667, 0.667, 0.667], "y": [1, 1, 1]},
					"o": {"x": [0.333, 0.333, 0.333], "y": [0, 0, 0]},
					"t": 251,
					"s": [100, 100, 100]
				}, {
					"i": {"x": [0.667, 0.667, 0.667], "y": [1, 1, 1]},
					"o": {"x": [0.333, 0.333, 0.333], "y": [0, 0, 0]},
					"t": 281,
					"s": [80, 80, 100]
				}, {
					"i": {"x": [0.667, 0.667, 0.667], "y": [1, 1, 1]},
					"o": {"x": [0.333, 0.333, 0.333], "y": [0, 0, 0]},
					"t": 311,
					"s": [100, 100, 100]
				}, {
					"i": {"x": [0.667, 0.667, 0.667], "y": [1, 1, 1]},
					"o": {"x": [0.333, 0.333, 0.333], "y": [0, 0, 0]},
					"t": 341,
					"s": [80, 80, 100]
				}, {"t": 371, "s": [100, 100, 100]}],
				"ix": 6,
				"l": 2
			}
		},
		"ao": 0,
		"shapes": [{
			"ty": "gr",
			"it": [{
				"ind": 0,
				"ty": "sh",
				"ix": 1,
				"ks": {
					"a": 0,
					"k": {
						"i": [[0, 0], [0, 0]],
						"o": [[0, 0], [0, 0]],
						"v": [[1.462, -0.422], [-1.462, 0.422]],
						"c": false
					},
					"ix": 2
				},
				"nm": "Path 1",
				"mn": "ADBE Vector Shape - Group",
				"hd": false
			}, {
				"ty": "st",
				"c": {"a": 0, "k": [1, 1, 1, 1], "ix": 3},
				"o": {"a": 0, "k": 100, "ix": 4},
				"w": {"a": 0, "k": 1.25, "ix": 5},
				"lc": 2,
				"lj": 1,
				"ml": 4,
				"bm": 0,
				"nm": "Stroke 1",
				"mn": "ADBE Vector Graphic - Stroke",
				"hd": false
			}, {
				"ty": "tr",
				"p": {"a": 0, "k": [2.087, 2.087], "ix": 2},
				"a": {"a": 0, "k": [0, 0], "ix": 1},
				"s": {"a": 0, "k": [100, 100], "ix": 3},
				"r": {"a": 0, "k": 0, "ix": 6},
				"o": {"a": 0, "k": 100, "ix": 7},
				"sk": {"a": 0, "k": 0, "ix": 4},
				"sa": {"a": 0, "k": 0, "ix": 5},
				"nm": "Transform"
			}],
			"nm": "Group 1",
			"np": 2,
			"cix": 2,
			"bm": 0,
			"ix": 1,
			"mn": "ADBE Vector Group",
			"hd": false
		}, {
			"ty": "gr",
			"it": [{
				"ind": 0,
				"ty": "sh",
				"ix": 1,
				"ks": {
					"a": 0,
					"k": {
						"i": [[0, 0], [0, 0]],
						"o": [[0, 0], [0, 0]],
						"v": [[-0.421, -1.462], [0.421, 1.462]],
						"c": false
					},
					"ix": 2
				},
				"nm": "Path 1",
				"mn": "ADBE Vector Shape - Group",
				"hd": false
			}, {
				"ty": "st",
				"c": {"a": 0, "k": [1, 1, 1, 1], "ix": 3},
				"o": {"a": 0, "k": 100, "ix": 4},
				"w": {"a": 0, "k": 1.25, "ix": 5},
				"lc": 2,
				"lj": 1,
				"ml": 4,
				"bm": 0,
				"nm": "Stroke 1",
				"mn": "ADBE Vector Graphic - Stroke",
				"hd": false
			}, {
				"ty": "tr",
				"p": {"a": 0, "k": [2.087, 2.086], "ix": 2},
				"a": {"a": 0, "k": [0, 0], "ix": 1},
				"s": {"a": 0, "k": [100, 100], "ix": 3},
				"r": {"a": 0, "k": 0, "ix": 6},
				"o": {"a": 0, "k": 100, "ix": 7},
				"sk": {"a": 0, "k": 0, "ix": 4},
				"sa": {"a": 0, "k": 0, "ix": 5},
				"nm": "Transform"
			}],
			"nm": "Group 2",
			"np": 2,
			"cix": 2,
			"bm": 0,
			"ix": 2,
			"mn": "ADBE Vector Group",
			"hd": false
		}],
		"ip": 95,
		"op": 815,
		"st": 95,
		"bm": 0
	}, {
		"ddd": 0,
		"ind": 16,
		"ty": 4,
		"nm": "Layer 4 Outlines",
		"sr": 1,
		"ks": {
			"o": {"a": 0, "k": 100, "ix": 11},
			"r": {"a": 0, "k": 0, "ix": 10},
			"p": {
				"a": 1,
				"k": [{
					"i": {"x": 0.667, "y": 1},
					"o": {"x": 0.333, "y": 0},
					"t": 86,
					"s": [294.967, 146.75, 0],
					"to": [0, 8.333, 0],
					"ti": [0, -8.333, 0]
				}, {"t": 106, "s": [294.967, 196.75, 0]}],
				"ix": 2,
				"l": 2
			},
			"a": {"a": 0, "k": [15.5, 29, 0], "ix": 1, "l": 2},
			"s": {
				"a": 1,
				"k": [{
					"i": {"x": [0.667, 0.667, 0.667], "y": [1, 1, 1]},
					"o": {"x": [0.333, 0.333, 0.333], "y": [0, 0, 0]},
					"t": 86,
					"s": [0, 0, 100]
				}, {"t": 96, "s": [100, 100, 100]}],
				"ix": 6,
				"l": 2
			}
		},
		"ao": 0,
		"shapes": [{
			"ty": "gr",
			"it": [{
				"ind": 0,
				"ty": "sh",
				"ix": 1,
				"ks": {
					"a": 0,
					"k": {
						"i": [[0, 0], [0, 0], [0, 0], [0, 0]],
						"o": [[0, 0], [0, 0], [0, 0], [0, 0]],
						"v": [[7.392, -14.229], [7.392, -11.271], [-7.392, 14.229], [-7.392, 11.271]],
						"c": true
					},
					"ix": 2
				},
				"nm": "Path 1",
				"mn": "ADBE Vector Shape - Group",
				"hd": false
			}, {
				"ty": "fl",
				"c": {"a": 0, "k": [0.066666666667, 0.772549079446, 0.63137254902, 1], "ix": 4},
				"o": {"a": 0, "k": 100, "ix": 5},
				"r": 1,
				"bm": 0,
				"nm": "Fill 1",
				"mn": "ADBE Vector Graphic - Fill",
				"hd": false
			}, {
				"ty": "tr",
				"p": {"a": 0, "k": [7.641, 14.479], "ix": 2},
				"a": {"a": 0, "k": [0, 0], "ix": 1},
				"s": {"a": 0, "k": [100, 100], "ix": 3},
				"r": {"a": 0, "k": 0, "ix": 6},
				"o": {"a": 0, "k": 100, "ix": 7},
				"sk": {"a": 0, "k": 0, "ix": 4},
				"sa": {"a": 0, "k": 0, "ix": 5},
				"nm": "Transform"
			}],
			"nm": "Group 1",
			"np": 2,
			"cix": 2,
			"bm": 0,
			"ix": 1,
			"mn": "ADBE Vector Group",
			"hd": false
		}, {
			"ty": "gr",
			"it": [{
				"ind": 0,
				"ty": "sh",
				"ix": 1,
				"ks": {
					"a": 0,
					"k": {
						"i": [[0, 0], [0, 0], [0, 0], [0, 0]],
						"o": [[0, 0], [0, 0], [0, 0], [0, 0]],
						"v": [[-7.391, -14.229], [-7.391, -11.271], [7.391, 14.229], [7.391, 11.271]],
						"c": true
					},
					"ix": 2
				},
				"nm": "Path 1",
				"mn": "ADBE Vector Shape - Group",
				"hd": false
			}, {
				"ty": "fl",
				"c": {"a": 0, "k": [0.113725497676, 0.87450986376, 0.725490196078, 1], "ix": 4},
				"o": {"a": 0, "k": 100, "ix": 5},
				"r": 1,
				"bm": 0,
				"nm": "Fill 1",
				"mn": "ADBE Vector Graphic - Fill",
				"hd": false
			}, {
				"ty": "tr",
				"p": {"a": 0, "k": [22.424, 14.479], "ix": 2},
				"a": {"a": 0, "k": [0, 0], "ix": 1},
				"s": {"a": 0, "k": [100, 100], "ix": 3},
				"r": {"a": 0, "k": 0, "ix": 6},
				"o": {"a": 0, "k": 100, "ix": 7},
				"sk": {"a": 0, "k": 0, "ix": 4},
				"sa": {"a": 0, "k": 0, "ix": 5},
				"nm": "Transform"
			}],
			"nm": "Group 2",
			"np": 2,
			"cix": 2,
			"bm": 0,
			"ix": 2,
			"mn": "ADBE Vector Group",
			"hd": false
		}, {
			"ty": "gr",
			"it": [{
				"ind": 0,
				"ty": "sh",
				"ix": 1,
				"ks": {
					"a": 0,
					"k": {
						"i": [[0, 0], [0, 0], [0, 0]],
						"o": [[0, 0], [0, 0], [0, 0]],
						"v": [[0, -12.75], [14.723, 12.75], [-14.723, 12.75]],
						"c": true
					},
					"ix": 2
				},
				"nm": "Path 1",
				"mn": "ADBE Vector Shape - Group",
				"hd": false
			}, {
				"ty": "fl",
				"c": {"a": 0, "k": [0.149019607843, 0.984313785329, 0.819607902976, 1], "ix": 4},
				"o": {"a": 0, "k": 100, "ix": 5},
				"r": 1,
				"bm": 0,
				"nm": "Fill 1",
				"mn": "ADBE Vector Graphic - Fill",
				"hd": false
			}, {
				"ty": "tr",
				"p": {"a": 0, "k": [15.033, 15.957], "ix": 2},
				"a": {"a": 0, "k": [0, 0], "ix": 1},
				"s": {"a": 0, "k": [100, 100], "ix": 3},
				"r": {"a": 0, "k": 0, "ix": 6},
				"o": {"a": 0, "k": 100, "ix": 7},
				"sk": {"a": 0, "k": 0, "ix": 4},
				"sa": {"a": 0, "k": 0, "ix": 5},
				"nm": "Transform"
			}],
			"nm": "Group 3",
			"np": 2,
			"cix": 2,
			"bm": 0,
			"ix": 3,
			"mn": "ADBE Vector Group",
			"hd": false
		}, {
			"ty": "gr",
			"it": [{
				"ind": 0,
				"ty": "sh",
				"ix": 1,
				"ks": {
					"a": 0,
					"k": {
						"i": [[0, 0], [0, 0], [0, 0]],
						"o": [[0, 0], [0, 0], [0, 0]],
						"v": [[0, -12.75], [14.722, 12.75], [-14.722, 12.75]],
						"c": true
					},
					"ix": 2
				},
				"nm": "Path 1",
				"mn": "ADBE Vector Shape - Group",
				"hd": false
			}, {
				"ty": "fl",
				"c": {"a": 0, "k": [0.105882360421, 0.909803981407, 0.752941236309, 1], "ix": 4},
				"o": {"a": 0, "k": 100, "ix": 5},
				"r": 1,
				"bm": 0,
				"nm": "Fill 1",
				"mn": "ADBE Vector Graphic - Fill",
				"hd": false
			}, {
				"ty": "tr",
				"p": {"a": 0, "k": [15.033, 13], "ix": 2},
				"a": {"a": 0, "k": [0, 0], "ix": 1},
				"s": {"a": 0, "k": [100, 100], "ix": 3},
				"r": {"a": 0, "k": 0, "ix": 6},
				"o": {"a": 0, "k": 100, "ix": 7},
				"sk": {"a": 0, "k": 0, "ix": 4},
				"sa": {"a": 0, "k": 0, "ix": 5},
				"nm": "Transform"
			}],
			"nm": "Group 4",
			"np": 2,
			"cix": 2,
			"bm": 0,
			"ix": 4,
			"mn": "ADBE Vector Group",
			"hd": false
		}],
		"ip": 86,
		"op": 773,
		"st": 86,
		"bm": 0
	}, {
		"ddd": 0,
		"ind": 17,
		"ty": 4,
		"nm": "Layer 3 Outlines",
		"sr": 1,
		"ks": {
			"o": {"a": 0, "k": 100, "ix": 11},
			"r": {"a": 0, "k": 0, "ix": 10},
			"p": {
				"a": 1,
				"k": [{
					"i": {"x": 0.667, "y": 1},
					"o": {"x": 0.333, "y": 0},
					"t": 86,
					"s": [294.967, 262.293, 0],
					"to": [0, -10, 0],
					"ti": [0, 10, 0]
				}, {"t": 106, "s": [294.967, 202.293, 0]}],
				"ix": 2,
				"l": 2
			},
			"a": {"a": 0, "k": [15.5, 0, 0], "ix": 1, "l": 2},
			"s": {
				"a": 1,
				"k": [{
					"i": {"x": [0.667, 0.667, 0.667], "y": [1, 1, 1]},
					"o": {"x": [0.333, 0.333, 0.333], "y": [0, 0, 0]},
					"t": 86,
					"s": [0, 0, 100]
				}, {"t": 96, "s": [100, 100, 100]}],
				"ix": 6,
				"l": 2
			}
		},
		"ao": 0,
		"shapes": [{
			"ty": "gr",
			"it": [{
				"ind": 0,
				"ty": "sh",
				"ix": 1,
				"ks": {
					"a": 0,
					"k": {
						"i": [[0, 0], [0, 0], [0, 0], [0, 0]],
						"o": [[0, 0], [0, 0], [0, 0], [0, 0]],
						"v": [[-7.391, 14.228], [-7.391, 11.272], [7.391, -14.228], [7.391, -11.272]],
						"c": true
					},
					"ix": 2
				},
				"nm": "Path 1",
				"mn": "ADBE Vector Shape - Group",
				"hd": false
			}, {
				"ty": "fl",
				"c": {"a": 0, "k": [1, 0.160784313725, 0.160784313725, 1], "ix": 4},
				"o": {"a": 0, "k": 100, "ix": 5},
				"r": 1,
				"bm": 0,
				"nm": "Fill 1",
				"mn": "ADBE Vector Graphic - Fill",
				"hd": false
			}, {
				"ty": "tr",
				"p": {"a": 0, "k": [22.424, 14.479], "ix": 2},
				"a": {"a": 0, "k": [0, 0], "ix": 1},
				"s": {"a": 0, "k": [100, 100], "ix": 3},
				"r": {"a": 0, "k": 0, "ix": 6},
				"o": {"a": 0, "k": 100, "ix": 7},
				"sk": {"a": 0, "k": 0, "ix": 4},
				"sa": {"a": 0, "k": 0, "ix": 5},
				"nm": "Transform"
			}],
			"nm": "Group 1",
			"np": 2,
			"cix": 2,
			"bm": 0,
			"ix": 1,
			"mn": "ADBE Vector Group",
			"hd": false
		}, {
			"ty": "gr",
			"it": [{
				"ind": 0,
				"ty": "sh",
				"ix": 1,
				"ks": {
					"a": 0,
					"k": {
						"i": [[0, 0], [0, 0], [0, 0], [0, 0]],
						"o": [[0, 0], [0, 0], [0, 0], [0, 0]],
						"v": [[7.392, 14.228], [7.392, 11.272], [-7.392, -14.228], [-7.392, -11.272]],
						"c": true
					},
					"ix": 2
				},
				"nm": "Path 1",
				"mn": "ADBE Vector Shape - Group",
				"hd": false
			}, {
				"ty": "fl",
				"c": {"a": 0, "k": [0.850980451995, 0.137254901961, 0.137254901961, 1], "ix": 4},
				"o": {"a": 0, "k": 100, "ix": 5},
				"r": 1,
				"bm": 0,
				"nm": "Fill 1",
				"mn": "ADBE Vector Graphic - Fill",
				"hd": false
			}, {
				"ty": "tr",
				"p": {"a": 0, "k": [7.641, 14.479], "ix": 2},
				"a": {"a": 0, "k": [0, 0], "ix": 1},
				"s": {"a": 0, "k": [100, 100], "ix": 3},
				"r": {"a": 0, "k": 0, "ix": 6},
				"o": {"a": 0, "k": 100, "ix": 7},
				"sk": {"a": 0, "k": 0, "ix": 4},
				"sa": {"a": 0, "k": 0, "ix": 5},
				"nm": "Transform"
			}],
			"nm": "Group 2",
			"np": 2,
			"cix": 2,
			"bm": 0,
			"ix": 2,
			"mn": "ADBE Vector Group",
			"hd": false
		}, {
			"ty": "gr",
			"it": [{
				"ind": 0,
				"ty": "sh",
				"ix": 1,
				"ks": {
					"a": 0,
					"k": {
						"i": [[0, 0], [0, 0], [0, 0]],
						"o": [[0, 0], [0, 0], [0, 0]],
						"v": [[0, 12.75], [-14.723, -12.75], [14.723, -12.75]],
						"c": true
					},
					"ix": 2
				},
				"nm": "Path 1",
				"mn": "ADBE Vector Shape - Group",
				"hd": false
			}, {
				"ty": "fl",
				"c": {"a": 0, "k": [0.996078491211, 0.301960784314, 0.301960784314, 1], "ix": 4},
				"o": {"a": 0, "k": 100, "ix": 5},
				"r": 1,
				"bm": 0,
				"nm": "Fill 1",
				"mn": "ADBE Vector Graphic - Fill",
				"hd": false
			}, {
				"ty": "tr",
				"p": {"a": 0, "k": [15.033, 13], "ix": 2},
				"a": {"a": 0, "k": [0, 0], "ix": 1},
				"s": {"a": 0, "k": [100, 100], "ix": 3},
				"r": {"a": 0, "k": 0, "ix": 6},
				"o": {"a": 0, "k": 100, "ix": 7},
				"sk": {"a": 0, "k": 0, "ix": 4},
				"sa": {"a": 0, "k": 0, "ix": 5},
				"nm": "Transform"
			}],
			"nm": "Group 3",
			"np": 2,
			"cix": 2,
			"bm": 0,
			"ix": 3,
			"mn": "ADBE Vector Group",
			"hd": false
		}, {
			"ty": "gr",
			"it": [{
				"ind": 0,
				"ty": "sh",
				"ix": 1,
				"ks": {
					"a": 0,
					"k": {
						"i": [[0, 0], [0, 0], [0, 0]],
						"o": [[0, 0], [0, 0], [0, 0]],
						"v": [[0, 12.75], [-14.722, -12.75], [14.722, -12.75]],
						"c": true
					},
					"ix": 2
				},
				"nm": "Path 1",
				"mn": "ADBE Vector Shape - Group",
				"hd": false
			}, {
				"ty": "fl",
				"c": {"a": 0, "k": [0.996078491211, 0.301960784314, 0.301960784314, 1], "ix": 4},
				"o": {"a": 0, "k": 100, "ix": 5},
				"r": 1,
				"bm": 0,
				"nm": "Fill 1",
				"mn": "ADBE Vector Graphic - Fill",
				"hd": false
			}, {
				"ty": "tr",
				"p": {"a": 0, "k": [15.033, 15.957], "ix": 2},
				"a": {"a": 0, "k": [0, 0], "ix": 1},
				"s": {"a": 0, "k": [100, 100], "ix": 3},
				"r": {"a": 0, "k": 0, "ix": 6},
				"o": {"a": 0, "k": 100, "ix": 7},
				"sk": {"a": 0, "k": 0, "ix": 4},
				"sa": {"a": 0, "k": 0, "ix": 5},
				"nm": "Transform"
			}],
			"nm": "Group 4",
			"np": 2,
			"cix": 2,
			"bm": 0,
			"ix": 4,
			"mn": "ADBE Vector Group",
			"hd": false
		}],
		"ip": 86,
		"op": 773,
		"st": 86,
		"bm": 0
	}, {
		"ddd": 0,
		"ind": 18,
		"ty": 2,
		"nm": "glossy-3.png",
		"cl": "png",
		"refId": "image_13",
		"sr": 1,
		"ks": {
			"o": {
				"a": 1,
				"k": [{
					"i": {"x": [0.833], "y": [0.833]},
					"o": {"x": [0.167], "y": [0.167]},
					"t": 66,
					"s": [0]
				}, {"t": 77, "s": [100]}],
				"ix": 11
			},
			"r": {
				"a": 1,
				"k": [{"i": {"x": [0.4], "y": [1]}, "o": {"x": [0.6], "y": [0]}, "t": 66, "s": [-161]}, {
					"t": 104,
					"s": [0]
				}],
				"ix": 10
			},
			"p": {
				"a": 1,
				"k": [{
					"i": {"x": 0.4, "y": 1},
					"o": {"x": 0.6, "y": 0},
					"t": 66,
					"s": [84.25, 372.75, 0],
					"to": [0, -36.667, 0],
					"ti": [0, 36.667, 0]
				}, {"t": 104, "s": [84.25, 262.75, 0]}],
				"ix": 2,
				"l": 2
			},
			"a": {"a": 0, "k": [15.5, 15, 0], "ix": 1, "l": 2},
			"s": {"a": 0, "k": [56, 56, 100], "ix": 6, "l": 2}
		},
		"ao": 0,
		"ip": 66,
		"op": 786,
		"st": 66,
		"bm": 0
	}, {
		"ddd": 0,
		"ind": 19,
		"ty": 4,
		"nm": "Layer 13 Outlines",
		"sr": 1,
		"ks": {
			"o": {"a": 0, "k": 100, "ix": 11},
			"r": {
				"a": 1,
				"k": [{
					"i": {"x": [0.667], "y": [1]},
					"o": {"x": [0.333], "y": [0]},
					"t": 82,
					"s": [0]
				}, {"i": {"x": [0.667], "y": [1]}, "o": {"x": [0.333], "y": [0]}, "t": 116, "s": [120]}, {
					"t": 356,
					"s": [393]
				}],
				"ix": 10
			},
			"p": {"a": 0, "k": [64.5, 247, 0], "ix": 2, "l": 2},
			"a": {"a": 0, "k": [3.985, 3.985, 0], "ix": 1, "l": 2},
			"s": {
				"a": 1,
				"k": [{
					"i": {"x": [0.667, 0.667, 0.667], "y": [1, 1, 1]},
					"o": {"x": [0.333, 0.333, 0.333], "y": [0, 0, 0]},
					"t": 82,
					"s": [0, 0, 100]
				}, {
					"i": {"x": [0.667, 0.667, 0.667], "y": [1, 1, 1]},
					"o": {"x": [0.333, 0.333, 0.333], "y": [0, 0, 0]},
					"t": 116,
					"s": [100, 100, 100]
				}, {
					"i": {"x": [0.667, 0.667, 0.667], "y": [1, 1, 1]},
					"o": {"x": [0.333, 0.333, 0.333], "y": [0, 0, 0]},
					"t": 146,
					"s": [80, 80, 100]
				}, {
					"i": {"x": [0.667, 0.667, 0.667], "y": [1, 1, 1]},
					"o": {"x": [0.333, 0.333, 0.333], "y": [0, 0, 0]},
					"t": 176,
					"s": [100, 100, 100]
				}, {
					"i": {"x": [0.667, 0.667, 0.667], "y": [1, 1, 1]},
					"o": {"x": [0.333, 0.333, 0.333], "y": [0, 0, 0]},
					"t": 206,
					"s": [80, 80, 100]
				}, {
					"i": {"x": [0.667, 0.667, 0.667], "y": [1, 1, 1]},
					"o": {"x": [0.333, 0.333, 0.333], "y": [0, 0, 0]},
					"t": 236,
					"s": [100, 100, 100]
				}, {
					"i": {"x": [0.667, 0.667, 0.667], "y": [1, 1, 1]},
					"o": {"x": [0.333, 0.333, 0.333], "y": [0, 0, 0]},
					"t": 266,
					"s": [80, 80, 100]
				}, {
					"i": {"x": [0.667, 0.667, 0.667], "y": [1, 1, 1]},
					"o": {"x": [0.333, 0.333, 0.333], "y": [0, 0, 0]},
					"t": 296,
					"s": [100, 100, 100]
				}, {
					"i": {"x": [0.667, 0.667, 0.667], "y": [1, 1, 1]},
					"o": {"x": [0.333, 0.333, 0.333], "y": [0, 0, 0]},
					"t": 326,
					"s": [80, 80, 100]
				}, {"t": 356, "s": [100, 100, 100]}],
				"ix": 6,
				"l": 2
			}
		},
		"ao": 0,
		"shapes": [{
			"ty": "gr",
			"it": [{
				"ind": 0,
				"ty": "sh",
				"ix": 1,
				"ks": {
					"a": 0,
					"k": {
						"i": [[0, 0], [0, 0]],
						"o": [[0, 0], [0, 0]],
						"v": [[2.985, -0.298], [-2.985, 0.298]],
						"c": false
					},
					"ix": 2
				},
				"nm": "Path 1",
				"mn": "ADBE Vector Shape - Group",
				"hd": false
			}, {
				"ty": "st",
				"c": {"a": 0, "k": [1, 1, 1, 1], "ix": 3},
				"o": {"a": 0, "k": 100, "ix": 4},
				"w": {"a": 0, "k": 2, "ix": 5},
				"lc": 2,
				"lj": 1,
				"ml": 4,
				"bm": 0,
				"nm": "Stroke 1",
				"mn": "ADBE Vector Graphic - Stroke",
				"hd": false
			}, {
				"ty": "tr",
				"p": {"a": 0, "k": [3.985, 3.985], "ix": 2},
				"a": {"a": 0, "k": [0, 0], "ix": 1},
				"s": {"a": 0, "k": [100, 100], "ix": 3},
				"r": {"a": 0, "k": 0, "ix": 6},
				"o": {"a": 0, "k": 100, "ix": 7},
				"sk": {"a": 0, "k": 0, "ix": 4},
				"sa": {"a": 0, "k": 0, "ix": 5},
				"nm": "Transform"
			}],
			"nm": "Group 1",
			"np": 2,
			"cix": 2,
			"bm": 0,
			"ix": 1,
			"mn": "ADBE Vector Group",
			"hd": false
		}, {
			"ty": "gr",
			"it": [{
				"ind": 0,
				"ty": "sh",
				"ix": 1,
				"ks": {
					"a": 0,
					"k": {
						"i": [[0, 0], [0, 0]],
						"o": [[0, 0], [0, 0]],
						"v": [[-0.298, -2.985], [0.298, 2.985]],
						"c": false
					},
					"ix": 2
				},
				"nm": "Path 1",
				"mn": "ADBE Vector Shape - Group",
				"hd": false
			}, {
				"ty": "st",
				"c": {"a": 0, "k": [1, 1, 1, 1], "ix": 3},
				"o": {"a": 0, "k": 100, "ix": 4},
				"w": {"a": 0, "k": 2, "ix": 5},
				"lc": 2,
				"lj": 1,
				"ml": 4,
				"bm": 0,
				"nm": "Stroke 1",
				"mn": "ADBE Vector Graphic - Stroke",
				"hd": false
			}, {
				"ty": "tr",
				"p": {"a": 0, "k": [3.985, 3.985], "ix": 2},
				"a": {"a": 0, "k": [0, 0], "ix": 1},
				"s": {"a": 0, "k": [100, 100], "ix": 3},
				"r": {"a": 0, "k": 0, "ix": 6},
				"o": {"a": 0, "k": 100, "ix": 7},
				"sk": {"a": 0, "k": 0, "ix": 4},
				"sa": {"a": 0, "k": 0, "ix": 5},
				"nm": "Transform"
			}],
			"nm": "Group 2",
			"np": 2,
			"cix": 2,
			"bm": 0,
			"ix": 2,
			"mn": "ADBE Vector Group",
			"hd": false
		}],
		"ip": 82,
		"op": 802,
		"st": 82,
		"bm": 0
	}, {
		"ddd": 0,
		"ind": 20,
		"ty": 2,
		"nm": "glossy-3.png",
		"cl": "png",
		"refId": "image_13",
		"sr": 1,
		"ks": {
			"o": {
				"a": 1,
				"k": [{
					"i": {"x": [0.833], "y": [0.833]},
					"o": {"x": [0.167], "y": [0.167]},
					"t": 59,
					"s": [0]
				}, {"t": 70, "s": [100]}],
				"ix": 11
			},
			"r": {
				"a": 1,
				"k": [{"i": {"x": [0.4], "y": [1]}, "o": {"x": [0.6], "y": [0]}, "t": 59, "s": [195]}, {
					"t": 97,
					"s": [0]
				}],
				"ix": 10
			},
			"p": {
				"a": 1,
				"k": [{
					"i": {"x": 0.4, "y": 1},
					"o": {"x": 0.6, "y": 0},
					"t": 59,
					"s": [70.25, 410.25, 0],
					"to": [0, -36.667, 0],
					"ti": [0, 36.667, 0]
				}, {"t": 97, "s": [70.25, 260.25, 0]}],
				"ix": 2,
				"l": 2
			},
			"a": {"a": 0, "k": [15.5, 15, 0], "ix": 1, "l": 2},
			"s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
		},
		"ao": 0,
		"ip": 59,
		"op": 779,
		"st": 59,
		"bm": 0
	}, {
		"ddd": 0,
		"ind": 21,
		"ty": 4,
		"nm": "Layer 11 Outlines",
		"sr": 1,
		"ks": {
			"o": {
				"a": 1,
				"k": [{
					"i": {"x": [0.833], "y": [0.833]},
					"o": {"x": [0.167], "y": [0.167]},
					"t": 89,
					"s": [0]
				}, {"t": 94, "s": [100]}],
				"ix": 11
			},
			"r": {
				"a": 1,
				"k": [{
					"i": {"x": [0.833], "y": [0.833]},
					"o": {"x": [0.333], "y": [0]},
					"t": 89,
					"s": [-46]
				}, {
					"i": {"x": [0.833], "y": [0.833]},
					"o": {"x": [0.167], "y": [0.167]},
					"t": 110,
					"s": [0]
				}, {"t": 184, "s": [62]}],
				"ix": 10
			},
			"p": {"a": 0, "k": [193.5, 393, 0], "ix": 2, "l": 2},
			"a": {"a": 0, "k": [90.073, 122.573, 0], "ix": 1, "l": 2},
			"s": {"a": 0, "k": [100, 100, 100], "ix": 6, "l": 2}
		},
		"ao": 0,
		"shapes": [{
			"ty": "gr",
			"it": [{
				"ind": 0,
				"ty": "sh",
				"ix": 1,
				"ks": {
					"a": 0,
					"k": {
						"i": [[0, 0], [11.083, -10.173]],
						"o": [[-14.061, 5.952], [0, 0]],
						"v": [[18.982, -12.218], [-18.982, 12.218]],
						"c": false
					},
					"ix": 2
				},
				"nm": "Path 1",
				"mn": "ADBE Vector Shape - Group",
				"hd": false
			}, {
				"ty": "st",
				"c": {"a": 0, "k": [1, 1, 1, 1], "ix": 3},
				"o": {"a": 0, "k": 100, "ix": 4},
				"w": {"a": 0, "k": 2, "ix": 5},
				"lc": 2,
				"lj": 2,
				"bm": 0,
				"nm": "Stroke 1",
				"mn": "ADBE Vector Graphic - Stroke",
				"hd": false
			}, {
				"ty": "tr",
				"p": {"a": 0, "k": [19.982, 13.218], "ix": 2},
				"a": {"a": 0, "k": [0, 0], "ix": 1},
				"s": {"a": 0, "k": [100, 100], "ix": 3},
				"r": {"a": 0, "k": 0, "ix": 6},
				"o": {"a": 0, "k": 100, "ix": 7},
				"sk": {"a": 0, "k": 0, "ix": 4},
				"sa": {"a": 0, "k": 0, "ix": 5},
				"nm": "Transform"
			}],
			"nm": "Group 1",
			"np": 2,
			"cix": 2,
			"bm": 0,
			"ix": 1,
			"mn": "ADBE Vector Group",
			"hd": false
		}],
		"ip": 53,
		"op": 773,
		"st": 53,
		"bm": 0
	}, {
		"ddd": 0,
		"ind": 22,
		"ty": 4,
		"nm": "Layer 9 Outlines",
		"sr": 1,
		"ks": {
			"o": {"a": 0, "k": 100, "ix": 11},
			"r": {"a": 0, "k": 0, "ix": 10},
			"p": {"a": 0, "k": [194, 397, 0], "ix": 2, "l": 2},
			"a": {"a": 0, "k": [85.75, 85.25, 0], "ix": 1, "l": 2},
			"s": {
				"a": 1,
				"k": [{
					"i": {"x": [0.4, 0.4, 0.4], "y": [1, 1, 1]},
					"o": {"x": [0.6, 0.6, 0.6], "y": [0, 0, 0]},
					"t": 61,
					"s": [0, 0, 100]
				}, {"t": 84, "s": [100, 100, 100]}],
				"ix": 6,
				"l": 2
			}
		},
		"ao": 0,
		"shapes": [{
			"ty": "gr",
			"it": [{
				"ind": 0,
				"ty": "sh",
				"ix": 1,
				"ks": {
					"a": 0,
					"k": {
						"i": [[0, -46.944], [-47.22, 0], [0, 46.944], [47.22, 0]],
						"o": [[0, 46.944], [47.22, 0], [0, -46.944], [-47.22, 0]],
						"v": [[-79.5, -9], [6, 76], [91.5, -9], [6, -94]],
						"c": true
					},
					"ix": 2
				},
				"nm": "Path 2",
				"mn": "ADBE Vector Shape - Group",
				"hd": false
			}, {
				"ty": "fl",
				"c": {"a": 0, "k": [0.117647066303, 0.933333393172, 0.776470648074, 1], "ix": 4},
				"o": {"a": 0, "k": 100, "ix": 5},
				"r": 1,
				"bm": 0,
				"nm": "Fill 1",
				"mn": "ADBE Vector Graphic - Fill",
				"hd": false
			}, {
				"ty": "tr",
				"p": {"a": 0, "k": [79.75, 94.25], "ix": 2},
				"a": {"a": 0, "k": [0, 0], "ix": 1},
				"s": {"a": 0, "k": [100, 100], "ix": 3},
				"r": {"a": 0, "k": 0, "ix": 6},
				"o": {"a": 0, "k": 100, "ix": 7},
				"sk": {"a": 0, "k": 0, "ix": 4},
				"sa": {"a": 0, "k": 0, "ix": 5},
				"nm": "Transform"
			}],
			"nm": "Group 1",
			"np": 2,
			"cix": 2,
			"bm": 0,
			"ix": 1,
			"mn": "ADBE Vector Group",
			"hd": false
		}],
		"ip": 61,
		"op": 781,
		"st": 61,
		"bm": 0
	}, {
		"ddd": 0,
		"ind": 23,
		"ty": 4,
		"nm": "Layer 8 Outlines",
		"sr": 1,
		"ks": {
			"o": {"a": 0, "k": 25, "ix": 11},
			"r": {"a": 0, "k": 0, "ix": 10},
			"p": {"a": 0, "k": [194, 393.5, 0], "ix": 2, "l": 2},
			"a": {"a": 0, "k": [132.5, 132.5, 0], "ix": 1, "l": 2},
			"s": {
				"a": 1,
				"k": [{
					"i": {"x": [0.4, 0.4, 0.4], "y": [1, 1, 1]},
					"o": {"x": [0.6, 0.6, 0.6], "y": [0, 0, 0]},
					"t": 53,
					"s": [0, 0, 100]
				}, {"t": 76, "s": [100, 100, 100]}],
				"ix": 6,
				"l": 2
			}
		},
		"ao": 0,
		"shapes": [{
			"ty": "gr",
			"it": [{
				"ty": "gr",
				"it": [{
					"ind": 0,
					"ty": "sh",
					"ix": 1,
					"ks": {
						"a": 0,
						"k": {
							"i": [[0, -73.178], [-73.177, 0], [0, 73.178], [73.178, 0]],
							"o": [[0, 73.178], [73.178, 0], [0, -73.178], [-73.177, 0]],
							"v": [[-132.5, 0], [0, 132.5], [132.5, 0], [0, -132.5]],
							"c": true
						},
						"ix": 2
					},
					"nm": "Path 4",
					"mn": "ADBE Vector Shape - Group",
					"hd": false
				}, {
					"ty": "tr",
					"p": {"a": 0, "k": [0, 0], "ix": 2},
					"a": {"a": 0, "k": [0, 0], "ix": 1},
					"s": {"a": 0, "k": [100, 100], "ix": 3},
					"r": {"a": 0, "k": 0, "ix": 6},
					"o": {"a": 0, "k": 100, "ix": 7},
					"sk": {"a": 0, "k": 0, "ix": 4},
					"sa": {"a": 0, "k": 0, "ix": 5},
					"nm": "Transform"
				}],
				"nm": "Group 1",
				"np": 1,
				"cix": 2,
				"bm": 0,
				"ix": 1,
				"mn": "ADBE Vector Group",
				"hd": false
			}, {
				"ty": "gf",
				"o": {"a": 0, "k": 100, "ix": 10},
				"r": 1,
				"bm": 0,
				"g": {
					"p": 3,
					"k": {
						"a": 0,
						"k": [0, 0.765, 0.678, 0.996, 0.17, 0.663, 0.543, 0.975, 1, 0.561, 0.408, 0.953],
						"ix": 9
					}
				},
				"s": {"a": 0, "k": [4, 46], "ix": 5},
				"e": {"a": 0, "k": [-7, 133], "ix": 6},
				"t": 1,
				"nm": "Gradient Fill 1",
				"mn": "ADBE Vector Graphic - G-Fill",
				"hd": false
			}, {
				"ty": "tr",
				"p": {"a": 0, "k": [132.5, 132.5], "ix": 2},
				"a": {"a": 0, "k": [0, 0], "ix": 1},
				"s": {"a": 0, "k": [100, 100], "ix": 3},
				"r": {"a": 0, "k": 0, "ix": 6},
				"o": {"a": 0, "k": 100, "ix": 7},
				"sk": {"a": 0, "k": 0, "ix": 4},
				"sa": {"a": 0, "k": 0, "ix": 5},
				"nm": "Transform"
			}],
			"nm": "Group 1",
			"np": 2,
			"cix": 2,
			"bm": 0,
			"ix": 1,
			"mn": "ADBE Vector Group",
			"hd": false
		}],
		"ip": 53,
		"op": 773,
		"st": 53,
		"bm": 0
	}, {
		"ddd": 0,
		"ind": 24,
		"ty": 4,
		"nm": "Layer 7 Outlines",
		"sr": 1,
		"ks": {
			"o": {"a": 0, "k": 7, "ix": 11},
			"r": {"a": 0, "k": 0, "ix": 10},
			"p": {"a": 0, "k": [194, 393.5, 0], "ix": 2, "l": 2},
			"a": {"a": 0, "k": [169.5, 169.5, 0], "ix": 1, "l": 2},
			"s": {
				"a": 1,
				"k": [{
					"i": {"x": [0.4, 0.4, 0.4], "y": [1, 1, 1]},
					"o": {"x": [0.6, 0.6, 0.6], "y": [0, 0, 0]},
					"t": 46,
					"s": [0, 0, 100]
				}, {"t": 69, "s": [100, 100, 100]}],
				"ix": 6,
				"l": 2
			}
		},
		"ao": 0,
		"shapes": [{
			"ty": "gr",
			"it": [{
				"ind": 0,
				"ty": "sh",
				"ix": 1,
				"ks": {
					"a": 0,
					"k": {
						"i": [[0, -93.06], [-93.061, 0], [0, 93.06], [93.059, 0]],
						"o": [[0, 93.06], [93.059, 0], [0, -93.06], [-93.061, 0]],
						"v": [[-168.5, 0], [0, 168.5], [168.5, 0], [0, -168.5]],
						"c": true
					},
					"ix": 2
				},
				"nm": "Path 1",
				"mn": "ADBE Vector Shape - Group",
				"hd": false
			}, {
				"ty": "st",
				"c": {"a": 0, "k": [1, 1, 1, 1], "ix": 3},
				"o": {"a": 0, "k": 100, "ix": 4},
				"w": {"a": 0, "k": 2, "ix": 5},
				"lc": 1,
				"lj": 1,
				"ml": 4,
				"bm": 0,
				"nm": "Stroke 1",
				"mn": "ADBE Vector Graphic - Stroke",
				"hd": false
			}, {
				"ty": "tr",
				"p": {"a": 0, "k": [169.5, 169.5], "ix": 2},
				"a": {"a": 0, "k": [0, 0], "ix": 1},
				"s": {"a": 0, "k": [100, 100], "ix": 3},
				"r": {"a": 0, "k": 0, "ix": 6},
				"o": {"a": 0, "k": 100, "ix": 7},
				"sk": {"a": 0, "k": 0, "ix": 4},
				"sa": {"a": 0, "k": 0, "ix": 5},
				"nm": "Transform"
			}],
			"nm": "Group 1",
			"np": 2,
			"cix": 2,
			"bm": 0,
			"ix": 1,
			"mn": "ADBE Vector Group",
			"hd": false
		}],
		"ip": 46,
		"op": 766,
		"st": 46,
		"bm": 0
	}, {
		"ddd": 0,
		"ind": 25,
		"ty": 4,
		"nm": "Layer 6 Outlines",
		"sr": 1,
		"ks": {
			"o": {"a": 0, "k": 7, "ix": 11},
			"r": {"a": 0, "k": 0, "ix": 10},
			"p": {"a": 0, "k": [194, 383.5, 0], "ix": 2, "l": 2},
			"a": {"a": 0, "k": [212.5, 212.5, 0], "ix": 1, "l": 2},
			"s": {
				"a": 1,
				"k": [{
					"i": {"x": [0.4, 0.4, 0.4], "y": [1, 1, 1]},
					"o": {"x": [0.6, 0.6, 0.6], "y": [0, 0, 0]},
					"t": 39,
					"s": [0, 0, 100]
				}, {"t": 62, "s": [100, 100, 100]}],
				"ix": 6,
				"l": 2
			}
		},
		"ao": 0,
		"shapes": [{
			"ty": "gr",
			"it": [{
				"ind": 0,
				"ty": "sh",
				"ix": 1,
				"ks": {
					"a": 0,
					"k": {
						"i": [[0, -116.808], [-116.808, 0], [0, 116.808], [116.808, 0]],
						"o": [[0, 116.808], [116.808, 0], [0, -116.808], [-116.808, 0]],
						"v": [[-211.5, 0], [0, 211.5], [211.5, 0], [0, -211.5]],
						"c": true
					},
					"ix": 2
				},
				"nm": "Path 1",
				"mn": "ADBE Vector Shape - Group",
				"hd": false
			}, {
				"ty": "st",
				"c": {"a": 0, "k": [1, 1, 1, 1], "ix": 3},
				"o": {"a": 0, "k": 100, "ix": 4},
				"w": {"a": 0, "k": 2, "ix": 5},
				"lc": 1,
				"lj": 1,
				"ml": 4,
				"bm": 0,
				"nm": "Stroke 1",
				"mn": "ADBE Vector Graphic - Stroke",
				"hd": false
			}, {
				"ty": "tr",
				"p": {"a": 0, "k": [212.5, 212.5], "ix": 2},
				"a": {"a": 0, "k": [0, 0], "ix": 1},
				"s": {"a": 0, "k": [100, 100], "ix": 3},
				"r": {"a": 0, "k": 0, "ix": 6},
				"o": {"a": 0, "k": 100, "ix": 7},
				"sk": {"a": 0, "k": 0, "ix": 4},
				"sa": {"a": 0, "k": 0, "ix": 5},
				"nm": "Transform"
			}],
			"nm": "Group 1",
			"np": 2,
			"cix": 2,
			"bm": 0,
			"ix": 1,
			"mn": "ADBE Vector Group",
			"hd": false
		}],
		"ip": 39,
		"op": 759,
		"st": 39,
		"bm": 0
	}, {
		"ddd": 0,
		"ind": 26,
		"ty": 4,
		"nm": "Layer 5 Outlines",
		"sr": 1,
		"ks": {
			"o": {"a": 0, "k": 100, "ix": 11},
			"r": {"a": 0, "k": 0, "ix": 10},
			"p": {"a": 0, "k": [188, 406, 0], "ix": 2, "l": 2},
			"a": {"a": 0, "k": [187.75, 406.25, 0], "ix": 1, "l": 2},
			"s": {"a": 0, "k": [113.834, 102.954, 100], "ix": 6, "l": 2}
		},
		"ao": 0,
		"shapes": [{
			"ty": "gr",
			"it": [{
				"ty": "gr",
				"it": [{
					"ind": 0,
					"ty": "sh",
					"ix": 1,
					"ks": {
						"a": 0,
						"k": {
							"i": [[0, 0], [0, 0], [0, 0], [0, 0]],
							"o": [[0, 0], [0, 0], [0, 0], [0, 0]],
							"v": [[-187.5, 406], [187.5, 406], [187.5, -406], [-187.5, -406]],
							"c": true
						},
						"ix": 2
					},
					"nm": "Path 1",
					"mn": "ADBE Vector Shape - Group",
					"hd": false
				}, {
					"ty": "tr",
					"p": {"a": 0, "k": [0, 0], "ix": 2},
					"a": {"a": 0, "k": [0, 0], "ix": 1},
					"s": {"a": 0, "k": [100, 100], "ix": 3},
					"r": {"a": 0, "k": 0, "ix": 6},
					"o": {"a": 0, "k": 100, "ix": 7},
					"sk": {"a": 0, "k": 0, "ix": 4},
					"sa": {"a": 0, "k": 0, "ix": 5},
					"nm": "Transform"
				}],
				"nm": "Group 1",
				"np": 1,
				"cix": 2,
				"bm": 0,
				"ix": 1,
				"mn": "ADBE Vector Group",
				"hd": false
			}, {
				"ty": "gf",
				"o": {"a": 0, "k": 100, "ix": 10},
				"r": 1,
				"bm": 0,
				"g": {
					"p": 3,
					"k": {
						"a": 0,
						"k": [0, 0.765, 0.678, 0.996, 0.17, 0.663, 0.543, 0.975, 1, 0.561, 0.408, 0.953],
						"ix": 9
					}
				},
				"s": {"a": 0, "k": [0, 400.179], "ix": 5},
				"e": {"a": 0, "k": [6.882, -1111.178], "ix": 6},
				"t": 1,
				"nm": "Gradient Fill 1",
				"mn": "ADBE Vector Graphic - G-Fill",
				"hd": false
			}, {
				"ty": "tr",
				"p": {"a": 0, "k": [187.75, 406.25], "ix": 2},
				"a": {"a": 0, "k": [0, 0], "ix": 1},
				"s": {"a": 0, "k": [100, 100], "ix": 3},
				"r": {"a": 0, "k": 0, "ix": 6},
				"o": {"a": 0, "k": 100, "ix": 7},
				"sk": {"a": 0, "k": 0, "ix": 4},
				"sa": {"a": 0, "k": 0, "ix": 5},
				"nm": "Transform"
			}],
			"nm": "Group 1",
			"np": 2,
			"cix": 2,
			"bm": 0,
			"ix": 1,
			"mn": "ADBE Vector Group",
			"hd": false
		}],
		"ip": 0,
		"op": 720,
		"st": 0,
		"bm": 0
	}],
	"markers": []
}
